export default {
  "termsOfUse": "Podmienky používania",
  "goToHome": "Späť na hlavnú stránku",
  "choose": "Vybrať",
  "close": "Zavrieť",
  "moreInfo": "Viac informácií",
  "send": "Odoslať",
  "sendProcess": "Odosielanie",
  "sendSuccess": "Odoslané",
  "question": "Poradiť sa s lekárom",
  "freeDownload": "Stiahnite si zadarmo našu aplikáciu",
  "month": "Mesiac",
  "year": "Rok",
  "other": "Iné",
  "backToStart": "Späť na úvod",
  "backToOverview": "Späť na prehľad služieb",
  "or": "alebo",
  "czechLanguage": "Česky",
  "slovakLanguage": "Slovensky",
  "englishLanguage": "Anglicky",
  "goNext": "Pokračovať",
  "goPrev": "späť",
  "save": "Uložiť",
  "show": "Ukázať",
  "showMore": "Zobraziť viac",
  "showAll": "Ukázať všetky",
  "saveChanges": "Uložiť zmeny",
  "saveChangesProcess": "Ukladanie",
  "saveChangesSuccess": "Uložené",
  "loginText": "Prihlásiť sa",
  "done": "Hotovo",
  "finish": "Dokončiť",
  "skip": "Preskočiť",
  "legalDocuments": "Právne dokumenty",
  "new": "Novinka",
  "free": "Zadarmo",
  "tryAgain": "Skúste to znova",
  "until": "do",
  "pilot": "Videohovor",
  "here": "tu",
  "subscribe": "Odoberať",
  "agree": "Súhlasím",
  "disagree": "Nesúhlasím",
  "alertInfo": {
    "title": "Služba uLekára.sk, s.r.o. nenahrádza záchrannú službu.",
    "text": "Pri akútnych problémoch volajte linku 155.",
    "errorText": "Toto pole je povinné."
  },
  "uLekare": {
    "title": "uLekára.sk"
  },
  "partners": {
    "otherPartners": "Partneri"
  },
  "questionForm": {
    "title": "Vaša otázka lekárovi",
    "modalTitle": "Priložte foto alebo lekárske správy.",
    "next": "Pokračovať",
    "firstName": {
      "title": "Meno",
      "placeholder": "Zadajte meno",
      "helpText": "Krstné meno zobrazíme pri otázkach na stránkach.",
      "helpTextNotShowing": "Meno je potrebné pre komunikáciu so zdravotným tímom.",
      "errorText": "Meno je povinné, prosím, vyplňte ho."
    },
    "lastName": {
      "title": "Priezvisko",
      "placeholder": "Zadajte priezvisko",
      "helpText": "Priezvisko je potrebné pre komunikáciu so zdravotným tímom.",
      "errorText": "Priezvisko je povinné, prosím, vyplňte ho."
    },
    "email": {
      "title": "E-mail",
      "placeholder": "meno@priklad.cz",
      "helpText": "Prostredníctvom e-mailu s vami budeme komunikovať.",
      "hrbHelpText": "Doporučujeme uviesť súkromný e-mail.",
      "errorText": "E-mailová adresa je povinná prosím, vyplňte ju.",
      "errorEmailText": "E-mailová adresa nie je v správnom formáte.",
      "errorEmailNotExisting": "Prosím, vyplňte existujúcu e-mailovú adresu.",
      "invalidBenefitEmail": "Neplatný e-mail"
    },
    "phone": {
      "title": "Telefón",
      "placeholder": "123 456 789",
      "helpText": "Poradíme, na koho sa obrátiť.",
      "errorText": "Telefónne číslo je povinné, prosím, vyplňte ho.",
      "errorPhoneText": "Zadajte telefónne číslo ({exampleNumber})."
    },
    "birthYear": {
      "title": "Rok narodenia",
      "titleRegistered": "Rok narodenia pacienta",
      "helpText": "Rok narodenia osoby, ktorej sa problém týka.",
      "errorText": "Rok narodenia je povinný, prosím, vyplňte ho.",
      "errorLengthText": "Rok narodenia napíšte v štvorcifernom formáte.",
      "errorBetweenText": "Napíšte skutočný rok narodenia."
    },
    "zipCode": {
      "title": "PSČ",
      "helpText": "Podľa PSČ vám odporučíme, kam sa objednať.",
      "errorText": "PSČ je povinné, prosím, vyplňte ho.",
      "errorZipCodeText": "PSČ nemá správny formát."
    },
    "insuranceCompany": {
      "title": "Poisťovňa",
      "errorText": "Pole je povinné. Prosím, vyberte poisťovňu.",
      "selectInsuranceCompany": "Vyberte svoju poisťovňu"
    },
    "timeAvailability": {
      "title": "Vaša časová dostupnosť",
      "errorText": "Pole je povinné. Prosím vyplňte časovú dostupnosť.",
      "placeholder": "Napíšte, aké sú vaše časové možnosti v nasledujúcich dňoch."
    }
  },
  "fileUpload": {
    "initial": "Kliknutím vyberte súbory alebo ich presuňte myšou.",
    "send": "Odoslať",
    "uploadAgain": "Skúste to znova.",
    "addFiles": "Priložte foto alebo lekárske správy.",
    "acceptedTypes": "Povolené typy sú obrázky (.jpg, .png). Maximálna povolená veľkosť súboru je 20 MB, maximálna povolená veľkosť všetkých súborov dohromady je 100 MB.",
    "typeError": "Tento typ súboru nie je podporovaný. Súbory nahrajte v uvedených formátoch .jpg, .png.",
    "sizeError": "Prekročená maximálna povolená veľkosť. Maximálna povolená veľkosť súboru je 20 MB, maximálna povolená veľkosť všetkých súborov dohromady je 100 MB.",
    "totalSizeError": "Maximálna veľkosť všetkých súborov je 100Mb"
  },
  "footer": {
    "copyright": "&copy; 2007-{thisYear} uLékaře.cz, s.r.o.",
    "issn": "ISSN 1802-5544",
    "companyTitle": "Spoločnosť uLekára.sk",
    "companyList": [
      {
        "title": "Kontakt"
      },
      {
        "title": "Kariéra",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Inzercia",
        "link": "https://www.ulekare.cz/inzerce",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Zdravie a prevencia vo firme",
        "link": "index",
        "partnerLink": "forCompanies",
        "thematicCounsellingLink": "forCompanies",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Zásady spracovania osobných údajov",
        "link": "personalDataProcessing",
        "partnerLink": "hrbPersonalDataProcessing",
        "thematicCounsellingLink": "thematicCounsellingPersonalDataProcessing",
        "forCompaniesLink": "forCompaniesPersonalDataProcessing",
        "aeskulabLink": "aeskuLabPersonalDataProcessing"
      },
      {
        "title": "Podmienky používania",
        "link": "termsAndConditions",
        "partnerLink": "hrbTermsAndConditions",
        "thematicCounsellingLink": "thematicCounsellingTermsAndConditions",
        "forCompaniesLink": "forCompaniesTermsAndConditions",
        "aeskulabLink": "aeskuLabTermsAndConditions"
      },
      {
        "title": "Prehlásenie o cookies",
        "link": "cookies",
        "partnerLink": "hrbCookies",
        "thematicCounsellingLink": "thematicCounsellingCookies",
        "forCompaniesLink": "forCompaniesCookies",
        "aeskulabLink": "aeskuLabCookies"
      }
    ],
    "perex": {
      "default": "V uLékara.sk veríme, že zdravie je vaše. Prostredníctvom technológie, ľudského prístupu a lekárskej expertízy pomáhame ľuďom riadiť si svoje zdravie. Tím viac než 350 lekárov všetkých špecializácií každý mesiac vyrieši v priemere 15 000 požiadaviek. Klientská zóna je používateľom k dispozícii 24 hodín denne, 7 dní v týždni nielen na webe, ale aj v mobilnej aplikácii a ponúka online lekársku poradňu, odborné články a tipy pre zdravie, sprievodcu zdravím a kalendár preventívnych prehliadok a očkovaní."
    }
  },
  "dataProcessing": {
    "iAgree": "Súhlasím so",
    "iAgreeWith": "Súhlasím s",
    "privacyPolicy": "spracovaním osobných údajov",
    "privacyPolicyTitle": "Súhlas so spracovaním osobných údajov vrátane osobitnej kategórie osobných údajov",
    "newsletterProcessing": "zasielaním noviniek a zliav uLekára.sk.",
    "newsletterText": "Súhlasím so zasielaním Spravodaja uLekára.sk (so správami o spoločnosti a projekte uLekára.sk, s.r.o., alebo o produktoch a službách spolupracujúcich tretích osôb). Súhlas so zasielaním odvoláte voľbou v Spravodajovi alebo na adrese <a href='mailto:osobniudaje@ulekare.cz'>osobniudaje@ulekare.cz</a>.",
    "conferenceNewsletterTitle": "Súhlas so zasielaním informačných emailov(newsletterov)",
    "conferenceDataTitle": "Súhlasím so spracovaním osobných údajov",
    "termsConditions": "podmienkami používania",
    "privacyPolicyInAccordance": "Vaše osobné údaje spracúvame v súlade so"
  },
  "termsAndConditions": {
    "title": "Podmienky používania"
  },
  "personalDataProcessing": {
    "title": "Súhlas so spracovaním osobných údajov"
  },
  "newsletter": {
    "title": "Súhlas so zasielaním marketingových oznámení"
  },
  "error": {
    "universal": "Vyskytla sa chyba",
    "sms": "Aktuálna doba doručenia sms je maximálne 5&nbsp;minút. Ďakujeme za trpezlivosť."
  },
  "errorLayout": {
    "title": "Ups! Niekde sa stala chyba.",
    "text": "Ospravedlňujeme sa, služba je dočasne nedostupná. Na oprave pracujeme. Prosíme, skúste to neskôr.",
    "button": "Späť na hlavnú stránku"
  },
  "meta": {
    "partnerNavigation": {
      "title": "Partnerská navigácia"
    },
    "termsAndConditions": {
      "title": "Podmienky používania"
    },
    "personalDataProcessing": {
      "title": "Zásady spracovania osobných údajov"
    },
    "emergency": {
      "title": "Kedy vyhľadať pohotovosť"
    },
    "mastercard": {
      "title": "Mastercard"
    },
    "overview": {
      "title": "Radíme, objednávame, pomáhame s prevenciou",
      "description": "Opýtajte sa našich lekárov na svoje zdravotné problémy alebo sa nechajte objednať k lekárovi. Pomôžeme vám so starostlivosťou o vaše zdravie. Online, zadarmo a kedykoľvek potrebujete."
    },
    "hrbOrderPage": {
      "title": "Objednáme vás k lekárovi",
      "description": "Hľadáte lekára, ktorý vás vyšetrí? Neviete, ku ktorému špecialistovi sa objednať? Nechajte to na nás. Objednávame k lekárom po celej ČR. Zadarmo a kedykoľvek potrebujete."
    },
    "hrbQuestionPage": {
      "title": "Opýtajte sa v našej online poradni",
      "description": "Zverte sa našim lekárom, do 6 hodín dostanete odpoveď na akúkoľvek vášu otázku týkajúcu sa fyzického aj duševného zdravia. Online, zadarmo a kedykoľvek potrebujete."
    },
    "hrbPreventionPage": {
      "title": "Prevencia",
      "description": "Pomáhame s prevenciou. Poraďte sa s našimi lekármi v otázkach starostlivosti o zdravie, získajte odporúčania týkajúce sa prevencie a objednajte sa na potrebné preventívne prehliadky."
    },
    "login": {
      "title": "Prihlásenie",
      "description": "Registrujte sa a majte na dosah ruky viac ako 350 lekárov všetkých špecializácií. Pomôžeme vám s objednaním k lekárovi po celej ČR. Zdravie je vaše."
    },
    "aeskulab": {
      "title": "Moje laboratórne výsledky",
      "description": "Získate interpretáciu vyšetrenia absolvovanú v laboratóriu Unilabs"
    },
    "dashboard": {
      "title": "Zdravie online"
    },
    "dashboardQuestions": {
      "title": "Poradňa"
    },
    "dashboardAppointments": {
      "title": "Objednanie k lekárovi"
    },
    "dashboardArticles": {
      "title": "Magazín Objevujte"
    },
    "dashboardConsultations": {
      "title": "Zodpovedané lékarmi"
    },
    "dashboardPrevention": {
      "title": "Moja prevencia"
    },
    "dashboardProfile": {
      "title": "Môj zdravotný profil"
    },
    "lostPassword": {
      "title": "Zabudnuté heslo"
    },
    "passwordReset": {
      "title": "Obnovenie hesla"
    },
    "emailVerification": {
      "title": "Overenie e-mailu"
    },
    "registration": {
      "title": "Registrácia"
    }
  },
  "conference": {
    "figureAlt": "HRajeme dál je aktivita, ktorá pomáha začleniť starostlivosť o zdravie a prevenciu medzi základné firemné stratégie."
  },
  "emergency": {
    "title1": "Kedy vyhľadať pohotovosť",
    "perex": "Ide o stručný súpis akútnych alebo život ohrozujúcich stavov, na ktoré chceme upozorniť pacientov s cieľom nasmerovať to nejurgentnějšie na pohotovosť, aby nedošlo k omeškaniu v ošetrení čakaním na odpoveď lekára v poradni. Najväčší obozretnosť je treba u detí.",
    "list": [
      {
        "title": "Úrazy a krvácanie",
        "body": [
          "veľké krvácenie, alebo <strong>jasné červené krvácanie, ktoré strieka</strong>",
          "veľmi silné krvácanie z genitálií mimo menštruačný cyklus alebo z konečníka",
          "otvorená či inak zrejmá zlomenina",
          "<strong>otvorené poranenia</strong> v hrudníku alebo v bruchu",
          "<strong>úrazy hlavy</strong> so stratou vedomia, zmenami správania, bolesťami hlavy, vracaním, rôzne veľkými zornicami, poruchami reči, zraku alebo hybnosti",
          "<strong>popáleniny u detí</strong>, zvlášť na hlave a rukách, genitálií alebo na väčšej ploche tela u dospelého",
          "úrazy <strong>elektrickým prúdom alebo bleskom</strong>"
        ]
      },
      {
        "title": "Bolesť na hrudi a pocity v hrudi",
        "body": [
          "bolesť v hrudníku, ktorá <strong>neprestáva</strong>, nereaguje na bežné lieky proti bolesti, či sa stupňuje, je <strong>zvieravá</strong>",
          "<strong>vystreľuje</strong> do ľavej ruky alebo do krku",
          "bolesť či <strong>porucha rytmu sprevádzaná zmenami vedomia</strong>, mdlobami",
          "ak máte podobné prejavy opakovane, alebo máte chorobu srdca a obehového systému",
          "bolesť na hrudi s dýchavičnosťou a významnými zmenami tlaku"
        ]
      },
      {
        "title": "Dýchavičnosť",
        "body": [
          "nemožnosť chytiť dych, pocit <strong>nedostatočnosti dychu</strong>",
          "<strong>lapavé dýchanie</strong> (ako ryba), dýchavičnosť, hvízdavý výdych",
          "nemožnosť dokončiť vetu bez nádychu, potreba sedieť alebo oprieť sa o ruky pre zlepšenie dýchania, prepadávanie jamky na krku a medzi ramenami a krkom",
          "<strong>zmena farby</strong> pier, uší alebo prstov na fialovú"
        ]
      },
      {
        "title": "Bolesť hlavy",
        "body": [
          "bolesť je <strong>krutá, nezvyklá, náhle</strong> vzniknutá, nereaguje na lieky",
          "<strong>budí v noci</strong>, prípadne nastupuje hneď po prebudení",
          "náhlej bolesti predchádzala veľká fyzická námaha vrátane sexuálnych aktivít",
          "bolesť je sprevádzaná tuhosťou šije, malátnosťou, spavosťou, poruchami vedomia, horúčkou",
          "bolesť hlavy v najbližších dňoch po úrazoch hlavy, zvlášť s poruchou vedomia, vracaním, motaním",
          "sprevádzaná <strong>poruchami zraku, reči, hybnosti</strong>"
        ]
      },
      {
        "title": "Bolesť brucha a prejavy v oblasti trávenia",
        "body": [
          "<strong>krutá alebo kolikovitá</strong> bolesť brucha",
          "<strong>zástava odchodu stolice</strong> alebo plynov s nadýmaním brucha, bolesti",
          "čierna stolica",
          "<strong>vracanie krve</strong>",
          "<strong>hrče na bruchu</strong>, v slabinách, na semenníku, ktorá bolí, nejde zatlačiť (nepokúšajte sa o to), je farebne zmenená oproti okoliu"
        ]
      },
      {
        "title": "Mdloby, porucha vedomia, kŕče",
        "body": [
          "náhle vzniknutá mdloba, pád, po ktorom sa dotyčný nebudí alebo nechová ako normálne",
          "stavy s <strong>poruchou vedomia, reči, videnia, hybnosti končatín</strong>",
          "celkové <strong>kŕče tela</strong>"
        ]
      },
      {
        "title": "Infekcie a horúčky",
        "body": [
          "stavy sprevádzané <strong>horúčkou nad 40°C, ktorá nejde znížiť váhe zodpovedajúcou dávkou lieku</strong>",
          "<strong>zimnica u detí, kŕče u detí pri horúčke</strong>",
          "opakované <strong>neztišitelné zvracanie a hnačky u detí</strong>, nedostatočný príjem tekutín u detí",
          "infekcie sprevádzané celkovými zmenami stavu/správania, ako výrazná spavosť, nevôľa, neschopnosť jesť, piť"
        ]
      },
      {
        "title": "Alergie a opuchy",
        "body": [
          "<strong>opuch tváre, krku a vo vnútri hrdla, opuch jazyka</strong>",
          "<strong>dýchavičnosť</strong>",
          "<strong>ťažkosti s prehĺtaním</strong>",
          "celotelové prejavy ako vyrážka alebo opuch",
          "jednostranný, hlavne bolestivý opuch končatiny sprevádzaný prípadne dýchavičnosťou alebo suchým kašľom"
        ]
      },
      {
        "title": "Zubná pohotovosť",
        "body": [
          "bolesť zubov s výraznou bolesťou hlavy",
          "bolesť zubov s horúčkami",
          "opuchy tváre a v oblasti zubov postupujúce na krk alebo sprevádzané ťažkosťami s prehĺtaním"
        ]
      },
      {
        "title": "Trestné činy",
        "body": [
          "v prípade, že máte podozrenie na trestný čin, volajte 112",
          "pokiaľ ide o život vám alebo niekomu z blízkych v dôsledku trestného činu, volajte 112",
          "ak ide o šikanovanie, ubližovanie na tele i na duši, volajte 112"
        ]
      },
      {
        "title": "Psychika",
        "body": [
          "pokiaľ ide o náhly stav zmätenosti, zmeny správania, agresivitu, volajte sanitku",
          "pokiaľ ide o hroziacu samovraždu, volajte sanitku"
        ]
      }
    ],
    "title2": "Volajte 155",
    "title": "Kedy vyhľadať pohotovosť"
  },
  "emergencyInfo": {
    "titleQuestion": "Skôr, než položíte otázku",
    "titleonco-prevention": "Skôr, než položíte otázku",
    "titleOrder": "Skôr, než položíte objednávku",
    "subtitle": "Služba uLekára.sk nenahrádza Zdravotnicku záchrannú službu.<br /><a href=\"{link}\" target=\"_blank\" class=\"black--text link--inline\">Kedy vyhľadať pohovotosť?</a>",
    "services": "Pri akútnych a život ohrozujúcích stavoch vždy <a href=\"tel:155\" class=\"link--inline black--text\">volajte 155 alebo 112</a>.",
    "continueQuestion": "Pokračovať v otázke",
    "continueOrder": "Pokračovať v objednávke",
    "dynamicForms": {
      "text": "uLekára.sk nenahrádza záchrannú službu. Pri život ohrozujúcich stavoch vždy volajte 155. {emergencyLink}",
      "linkText": "Kedy vyhľadať pohotovosť"
    }
  },
  "partnerb2b": {
    "mastercard": {
      "hello": {
        "title": "Online poradňa a&nbsp;objednanie k&nbsp;lekárovi",
        "perex": "Ako držiteľ prémiovej alebo firemnej karty Mastercard<sup>®</sup> môžete plne využívať služby uLekára, medzi ktoré patrí online lekárska poradňa, objednanie k lekárovi po celej ČR a celkovo lepšia starostlivosť o vaše zdravie."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Spýtajte sa kedykoľvek",
            "perex": "Odpoveď praktického lekára či pediatra dostanete do 6 hodín od položenia svojej otázky.",
            "footer": "Často sme rýchlejší."
          },
          {
            "icon": "mail",
            "title": "Počkajte na odpovede",
            "perex": "Praktický lekár môže požiadať o doplnenie odpovede špecialisty, napríklad dermatológa, ortopéda&nbsp;a pod.",
            "footer": "Pokrývame všetky špecializácie."
          },
          {
            "icon": "calendar/date-31",
            "title": "Nechajte sa objednať",
            "perex": "Ak naši odborníci odporučia osobnú návštevu lekára, objednáme vás.",
            "footer": "Objednať sa môžete aj priamo, bez položenia dotazu."
          }
        ]
      }
    },
    "eon": {
      "howItWorks": {
        "items": [
          {
            "title": "Spýtajte sa kedykoľvek"
          }
        ]
      }
    },
    "sporthelp": {
      "howItWorks": {
        "items": [
          {
            "title": "Spýtajte sa kedykoľvek",
            "perex": "Odpoveď praktického lekára či pediatra dostanete do 6 hodín od položenia svojej otázky."
          }
        ]
      }
    },
    "philips-sonicare": {
      "howItWorks": {
        "items": [
          {
            "title": "Spýtajte sa kedykoľvek",
            "perex": "Odpoveď praktického lekára či pediatra dostanete do 6 hodín od položenia svojej otázky."
          }
        ]
      }
    }
  },
  "masterCard": {
    "faq": "Často kladené otázky",
    "useService": "Využiť službu",
    "menu": {
      "question": "Poradiť sa s lekárom",
      "contact": "Kontakt"
    },
    "howItWorks": {
      "title": "Sme tu pre vás nonstop",
      "items": [
        {
          "icon": "chat",
          "title": "Spýtajte sa kedykoľvek",
          "perex": "Odpoveď praktického lekára či pediatra dostanete do 6 hodín od položenia svojej otázky.",
          "footer": "Často sme rýchlejší."
        },
        {
          "icon": "mail",
          "title": "Počkajte na odpovede",
          "perex": "Do 48 hodín obdržíte vyjadrenie tiež od špecialistu (napríklad dermatológa, ortopéda ai.).",
          "footer": "Pokrývame všetky špecializácie."
        },
        {
          "footer": "Objednať sa môžete aj priamo, bez položenia dotazu."
        }
      ]
    },
    "question": {
      "title": "Poradiť sa s lekárom",
      "perex": "Na vašu otázku odpovie praktický lekár a špecialista."
    },
    "appointment": {
      "title": "Objednať k lekárovi",
      "perex": "Sestra vám zavolá, vyhľadá lekára a objedná vás."
    },
    "authorization": {
      "title": "Overte si vašu kartu Mastercard<sup>®</sup>",
      "subtitle": {
        "question": "Potrebujeme overiť prvých 6 čísel vašej karty <strong>Mastercard<sup>®</sup> Premium</strong>. Nejedná sa o platbu, po úspešnom zadaní budete môcť využiť služieb uLekára.sk zadarmo.",
        "appointment": "Potrebujeme overiť prvých 6 čísel vašej karty <strong>Mastercard<sup>®</sup> Premium</strong>. Nejedná sa o platbu, po úspešnom zadaní budete môcť využiť služieb uLekára.sk zadarmo."
      },
      "codeLabel": "Vložte prvých 6 čísel svojej karty",
      "codeError": "Je nám ľúto, ale vami zadaná kombinácia číslic nezodpovedá prémiovej alebo firemnej karte Mastercard<sup>®</sup>.",
      "sendButton": "Overiť"
    }
  },
  "reauthorizationDashboard": {
    "heading": "Vaša bezplatná služba končí za {daysLeft} dní, dňa {dayFormat}.",
    "partnerText": "Služba uLékaře.cz je stále hradená spoločnosťou {currentPartnerName}.",
    "prolongText": "Predĺžte si výhody služby uLékaře.cz, aby ste ich mali naďalej zadarmo.",
    "prolongFamilyText": "Připomeňte svému blízkému, že byste chtěli službu prodloužit.",
    "buttonText": "Predĺžte si bezplatne",
    "inDay": "deň",
    "inDaysLow": "deň",
    "inDaysHigh": "dní",
    "selfPayNowHeading": "Teraz ste samoplatiteľom. Ale nemusíte byť.",
    "selfPayNowPartnerText": "Kto zaplatí za uLékaře.cz? Môže to byť váš zamestnávateľ, poisťovňa atď.",
    "selfPayNowProlongText": "Rozšírte si svoje výhody a získajte službu zadarmo. Rovnako ako predtým.",
    "selfPayNowFamilyPartnerText": "Pripomeňte svojmu blízkemu {currentPartnerName}.",
    "selfPayNowFamilyPartnerInfoText": "Keď obnoví svoju službu uLékaře.cz, dostanete všetky svoje výhody späť zadarmo."
  },
  "migraine": {
    "helloImageAlt": "Naša špecializovaná poradňa Linka o migréne vám môže pomôcť od bolestí hlavy a sprievodných prejavov migrenóznych záchvatov. Poradíme vám a nasmerujeme vás k účinnej liečbe."
  },
  "psoriasis": {
    "helloImageAlt": "Naša špecializovaná poradňa Ako vyzrieť na lupienku vám môže pomôcť s liečbou psoriázy. Poradíme vám a nasmerujeme vás k účinnej liečbe."
  },
  "hrbPage": {
    "hello": {
      "title": "Sme vaším sprievodcom na ceste za zdravím",
      "items": [
        {
          "text": "Sme lekári všetkých špecializácií.",
          "icon": "doctor"
        },
        {
          "text": "Sme dostupní 24 hodín denne, 7 dní v týždni.",
          "icon": "clock"
        },
        {
          "text": "Sme tu pre vás i vašu rodinu.",
          "icon": "rodina"
        }
      ]
    },
    "advisory": "Poradňa",
    "order": "Objednanie",
    "myHealth": "Na zdravie",
    "infolines": "Infolinky",
    "contact": "Kontakt",
    "registration": "Registrácia",
    "notification": {
      "title": "Od 25. - 17. novembra bude probiehať deň zdravia vo vašej firme"
    },
    "hrbArticles": {
      "title": "Buďte zdraví",
      "items": [
        {
          "icon": "shield",
          "title": "Prevencia nebolí",
          "perex": "Majte svoj život pod kontrolou vďaka pravidelnej starostlivosti o vlastné zdravie. Zistite si všetko o prevencii a jej možnostiach.",
          "linkName": "Zistiť viac",
          "link": "hrbArticles",
          "params": {
            "slug": "prevence"
          },
          "lang": "cs"
        },
        {
          "icon": "umbrella",
          "title": "Poisťovne pomáhajú",
          "perex": "Zmapovali sme príspevky a benefity všetkých 7 zdravotných poisťovní na rok 2021. Viete, čo ponúkajú?",
          "linkName": "Získať prehľad",
          "link": "hrbArticles",
          "params": {
            "slug": "pojistovny-pomahaji"
          },
          "lang": "cs"
        },
        {
          "icon": "news",
          "title": "Čítate? Čítajte!",
          "perex": "Bude ma baviť? Dozviem sa niečo nové? Dá sa mu veriť? Trikrát áno. Náš časopis je zdraviu prospešný na všetkých svojich stránkach.",
          "linkName": "Čítať časopis",
          "linkType": "external",
          "link": "https://www.ulekare.cz/novy-casopis-ulekare-cz"
        }
      ]
    },
    "serviceVideo": {
      "title": "Nikdy nemáme zatvorené a nemusíte klopať",
      "videoUrl": "https://www.youtube.com/embed/z8YK3f1GXpI"
    },
    "counseling": {
      "title": "Poradňa",
      "question": "Praktický lekár alebo pediater odpovie do 6 hodín od položenia otázky.",
      "specialist": "Vyjadrenie špecialistu získate do 72 hodín.",
      "order": "Ak naši odborníci odporučia osobnú návštevu lekára, objednáme vás.",
      "linkTitle": "Poradiť sa"
    },
    "ordering": {
      "title": "Objednání",
      "perex": [
        "Popíšte svoj zdravotný problém alebo uveďte, ktorého lekára hľadáte.",
        "Nájdeme vhodného odborníka vo vašom okolí.",
        "Objednáme vás na základe vašich časových možností."
      ],
      "linkTitle": "Objednať sa"
    },
    "prevention": {
      "title": "Na zdravie",
      "perex": [
        "S našim preventívnym programom predchádzate chorobám.",
        "Staráme sa, aby vaše telo i duša boli spokojné.",
        "Nasmerujeme vás, stačí uviesť niekoľko základných informácií."
      ],
      "linkTitle": "Idem do toho"
    },
    "faq": {
      "title": "Čo vás zaujíma?",
      "faqList": [
        {
          "title": "Čo je uLekára.sk?",
          "bodyText": "ÁNO, na všetko, čo sa týka fyzického a duševného zdravia."
        },
        {
          "title": "Musím zmeniť svojho lekára?",
          "bodyText": "NEMUSÍTE, službu môžete využiť \"iba\" pre druhý lekársky názor."
        },
        {
          "title": "Dozvie sa niečo môj existujúci lekár?",
          "bodyText": "NEDOZVIE, vaše otázky s nikým nezdieľame. Všetko prebieha online a len medzi vami a lekárom z poradne, ktorý na  otázku odpovedá."
        },
        {
          "title": "Budem niečo platiť za využitie služby?",
          "bodyText": "NIE, za využitie lekárskej online poradne nič neplatíte. Neodpočítajú sa vám ani kredity z benefitného programu, ak ho  firma má."
        },
        {
          "title": "Môžem sa opýtať na čokoľvek?",
          "bodyText": "ÁNO, na všetko, čo sa týka fyzického a duševného zdravia."
        },
        {
          "title": "Objednávate k slovenským lekárom?",
          "bodyText": "NIE, služba uLekára.sk na Slovensku slúži výhradne na online konzultáciu vášho zdravotného stavu."
        },
        {
          "title": "V rámci online konzultácií mi odpovedá slovenský lekár?",
          "bodyText": "NIE, na vašu otázku odpovedajú predovšetkým lekári pracujúci v Českej Republike a prevažne v češtine."
        },
        {
          "title": "Ako je zaistená diskrétnosť?",
          "bodyText": "Vašu otázku, krstné meno a vek vidí iba lekár, ktorý vám odpovedá. K ďalším informáciám uvedeným v rámci Vašej  požiadavky má prístup iba zdravotnícky tím, ktorý vám odpovedá na otázku. Vaše otázky nie sú ďalej s nikým  zdieľané. V prípade, že prikladáte lekársku správu či iný dokument, odporúčame najprv začierniť viditeľné osobné  údaje a až potom prílohu nahrať k otázke, aby bola dodržaná úplná anonymita aj z Vašej strany."
        },
        {
          "title": "Na webe uLekára.sk sú ale otázky zobrazené, budú tam i moje?",
          "bodyText": "NEBUDÚ, otázky osôb, ktoré majú službu aktívnu vďaka zamestnávateľovi, a to vrátane rodinných príslušníkov, nie sú  na stránkach zverejnené."
        }
      ]
    },
    "employeeStories": {
      "title": "Príbehy z našej poradne",
      "stories": [
        {
          "name": "Pomohol druhý lekársky názor",
          "perex": "Mamička 7-ročného chlapca si v našej poradni overovala správnosť postupu liečby ošetrujúcej kožnej lekárky, ku ktorej dochádzajú. Jej syna dlhodobo trápila urputná vyrážka, na ktorú nezaberala doterajšia liečba. Bol mu preto predpísaný liek na predpis, o ktorom sa žena pri vyzdvihnutí v lekárni dozvedela, že je určený dospelým. Vďaka tomu, že priložila fotografiu postihnutého miesta, mohla lekárka v našej poradni potvrdiť existujúcu diagnózu aj vhodnosť zvolenej liečby."
        },
        {
          "name": "Spadol jej kameň zo srdca",
          "perex": "Jednej z našich užívateliek jej gynekológ oznámil diagnózu v podobe dvoch skratiek a bez ďalšieho vysvetlenia ju poslal na ďalšie vyšetrenia. Ženu okamžite ovládol strach, že sa za tými strašidelne znejúcimi skratkami skrýva prízrak rakoviny. Lekári z našej poradne ju obaja zhodne upokojili, že sa jedná o prednádorový stav, ktorý je pomerne častý a automaticky neznamená, že trpí onkologickým ochorením. To by muselo potvrdiť ďalšie vyšetrenie. Žena zareagovala s pocitmi vďačnosti a slovami, že \"jej spadol zo srdca veľký kameň\"."
        },
        {
          "name": "Z našej poradne zamieril rovno k lekárovi",
          "perex": "Mladý muž sa na našu poradňu obrátil s otázkou na posúdenie znamienka na bruchu, ktoré sa mu \"nepozdávalo\", pripojil fotografiu daného znamienka a uviedol jeho približné rozmery. Špecialisti v našej poradni len zo snímky síce nemohli určiť jeho povahu, ale bolo z neho dostatočne zrejmé, že znamienko vykazuje istú asymetriu a nerovnosť okrajov. Na základe bezodkladného odporúčania absolvovať špecializované vyšetrenie, bol tento muž objednaný našou sestričkou na najbližší možný termín na dermatológiu v mieste bydliska."
        }
      ]
    },
    "contactUs": {
      "title": "Klientská podpora",
      "subTitle": "Neviete si rady? Potrebujete pomôcť s vyplnením formulára?"
    },
    "covidLink": {
      "title": "Covid infolinka",
      "callUs": "Volajte:",
      "tooltip": {
        "title": "S čím vám môžeme poradiť?",
        "text": [
          "Príznaky ochorenia",
          "Rizikové skupiny",
          "Koronavírus a tehotenstvo",
          "Testovanie",
          "Preventívne a hygienické opatrenia"
        ]
      }
    },
    "asistLink": {
      "subtitle": "Psychologické, právní a finanční poradenství",
      "email": "info@e-a.cz",
      "phone": "+421 950 105 650"
    }
  },
  "hrbPageInactive": {
    "title": "Ľutujeme, služba už nie je dostupná.<br/>Ak máte záujem službu opäť využívať, požiadajte svoje HR/personálne oddelenie.",
    "subtitle": "Službu uLekára.sk môžete využívať súkromne.",
    "getHelp": "Poradiť sa"
  },
  "authorization": {
    "title": "Aktivácia služby",
    "subtitle": "Aby ste mohli začať službu využívať, zadajte svoj firemný e-mail alebo kód, ktorý ste dostali od zamestnávateľa. Ďalej postupujte podľa pokynov.",
    "subtitleEmail": "Aby ste mohli začať službu využívať, zadajte svoj firemný e-mail, ktorý ste obdržali od zamestnávateľa. Ďalej postupujte podľa pokynov.",
    "subtitleCode": "Aby ste mohli začať službu využívať, zadajte kód, ktorý ste obdržali od zamestnávateľa. Ďalej postupujte podľa pokynov.",
    "emailLabel": "E-mail",
    "codeLabel": "Kód",
    "codeHrbError": "Neplatný kód",
    "codeLengthError": "Nesprávny formát. Kód musí obsahovať 2-20 znakov.",
    "or": "alebo",
    "contactTitle": "Neviete si rady?",
    "sendMessage": "Žiadosť na využitie služby uLekára.sk sme odoslali na <strong class='text-primary'>{email}</strong>. Schválenie žiadosti vykonáte kliknutím na odkaz v e-maile.",
    "changeEmail": "Zmeniť e-mail"
  },
  "checkToken": {
    "generateToken": "Zaslať nový odkaz",
    "expired": {
      "title": "Odkazu vypršala platnosť",
      "perex": "Z bezpečnostných dôvodov majú odkazy obmedzenú platnosť. Skúste si nechať zaslať odkaz nový."
    },
    "invalid": {
      "title": "Odkaz je už neplatný",
      "perex": "Zadaný odkaz už nefunguje. Môže to byť jeho použitím alebo zmenou podmienok."
    },
    "tokenCreated": {
      "title": "Odkaz bol odoslaný.",
      "perex": "Na váš firemný e-mail sme vám zaslali nový odkaz. Aktiváciu dokončíte kliknutím na tento odkaz v e-maile."
    }
  },
  "confirmation": {
    "title": "Potvrdenie e-mailu",
    "subtitle": "Kliknite na odkaz poslaný na e-mail <strong class='text-primary'>{email}</strong> a tým potvrdíte e-mail pre komunikáciu so službou uLekára.sk."
  },
  "hrbForm": {
    "title": "Využite službu uLekára.sk",
    "problem": {
      "text": "Napíšte, ako sa zdravotný problém prejavuje a ako dlho trvá.",
      "placeholder": "Čím viac informácií nám poskytnete, tým presnejšiu dostanete odpoveď od lekára.",
      "errorText": "Vyplňte, prosím, toto pole."
    },
    "help": {
      "text": "Na čo sa našich lekárov chcete opýtať?",
      "placeholder": "Položte lekárovi otázku.",
      "errorText": "Vyplňte, prosím, toto pole."
    },
    "medication": {
      "text": "Uveďte ďalšie informácie týkajúce sa vášho zdravotného stavu.",
      "placeholder": "Napr. s ktorými ďalšími chorobami sa liečite, ktoré lieky beriete pravidelne, či máte nejaké alergie a aké sú výsledky vyšetrenia.",
      "errorText": "Vyplňte, prosím, toto pole."
    },
    "order": {
      "question": {
        "text": "Aké ťažkosti riešite? Ako vám môžeme pomôcť?",
        "placeholder": "K akému lekárovi potrebujete objednať?",
        "errorText": "Vyplňte, prosím, toto pole."
      }
    },
    "agreements": {
      "iAgree": "Odoslaním formulára súhlasím s ",
      "conditions": "Podmienkami používania",
      "service": "služby uLekára.sk."
    },
    "thankYou": {
      "question": {
        "title": "Ďakujeme. Vaša otázka bola odoslaná.",
        "perex": "Otázku teraz odovzdáme lekárovi a ten na ňu zareaguje.<br/> Odpoveď dostanete v e-maile.",
        "button": "Nová otázka"
      },
      "appointment": {
        "title": "Ďakujeme. Vaša objednávka bola prijatá.",
        "perex": "Počkajte, prosím, na telefonát zdravotnej sestry",
        "button": "Nová objednávka"
      },
      "prevention": {
        "title": "Vaša registrácia do preventívneho programu uLekára.sk prebehla úspešne.",
        "content": {
          "start": "Na vašom zdraví nám záleží. Pomôžeme vám sa o neho lepšie starať a predchádzať tak chorobám a vážnym zdravotným problémom.",
          "list": [
            "Prostredníctvom e-mailových preventívnych výziev vám budeme pravidelne zasielať tipy, ako posilňovať svoje zdravie aj ktoré preventívne prehliadky a príspevky ponúkané vašou zdravotnou poisťovňou si nenechať ujsť.",
            "Vďaka našim zdravotným výzvam a informáciám budete mať vždy aktuálny prehľad, ako sa starať o seba aj svojich blízkych. Všetok obsah pritom pripravujeme v spolupráci s odborníkmi na dané témy.",
            "V príprave sú aj inšpiratívne články a videá, a najmä kalendár prehliadok a očkovaní pre vaše osobné využitie."
          ],
          "questionnaire": {
            "start": "Chcete zistiť, ako ste na tom s prevenciou vo svojom živote a zároveň nám tým pomôcť v príprave ďalších častí preventívneho programu na mieru vašim potrebám?",
            "middle": "Stačí vyplniť jednoduchý dotazník s 10 otázkami:",
            "link": "https://www.survio.com/survey/d/X7L8A2K3B4U9R5I0G"
          },
          "thankYou": "Ďakujeme.<br/><br/>Tím uLekára.sk"
        }
      }
    }
  },
  "masterCardFAQ": {
    "title": "Časté otázky a odpovede k službe uLekára.sk",
    "perex": "Možno aj&nbsp;vás napadajú otázky súvisiace s&nbsp;využitím služby lekárskej online poradne. Ponúkame vám odpovede na najčastejšie z&nbsp;nich.",
    "list": [
      {
        "title": "Môžem sa opýtať na čokoľvek?",
        "bodyText": "ÁNO, na všetko, čo sa týka fyzického a&nbsp;duševného zdravia."
      },
      {
        "title": "Skutočne objednávate ku všetkým lekárom?",
        "bodyText": "ÁNO, sestričky z&nbsp;uLékaře.cz vás objednajú k&nbsp;praktickému lekárovi aj&nbsp;špecialistom všetkých odborov."
      },
      {
        "title": "Musím zmeniť svojho lekára?",
        "bodyText": "NEMUSÍTE, službu môžete využiť aj napríklad len pre získanie ďalšieho lekárskeho názoru."
      },
      {
        "title": "Dozvie sa niečo môj existujúci lekár?",
        "bodyText": "NEDOZVIE, vaše otázky s&nbsp;nikým nezdieľame. Všetko prebieha online a&nbsp;len medzi vami a&nbsp;lekárom z&nbsp;poradne, ktorý na otázku odpovedá."
      },
      {
        "title": "Budem niečo platiť za využitie služby?",
        "bodyText": "NIE, za využitie lekárskej online poradne alebo objednanie k&nbsp;lekárovi nič neplatíte. Nárok na využitie služby zadarmo získate, ak ste držiteľom prémiovej či firemnej karty Mastercard<sup>®</sup>.<br/><br/><strong>Prémiové karty:</strong><ul><li>Mastercard<sup>®</sup> Gold</li><li>Mastercard<sup>®</sup> Platinum</li><li>Mastercard<sup>®</sup> World</li><li>Mastercard<sup>®</sup> World Elite</li></ul><strong>Firemné karty:</strong><ul><li>Mastercard<sup>®</sup> Business</li><li>Mastercard<sup>®</sup> Corporate</li></ul>"
      },
      {
        "title": "Budem platiť niečo lekárovi, ku ktorému ma objednáte?",
        "bodyText": "Rozhodnutie je na vás. Sestry objednávajú do štátnych i&nbsp;neštátnych zdravotníckych zariadení, hľadajú najvhodnejšieho lekára s&nbsp;ohľadom na termín návštevy a&nbsp;dostupnosť lekára danej odbornosti, všetko podľa vašich preferencií. O&nbsp;prípadnej platbe budete informovaný/á ešte pred samotnou návštevou lekára."
      },
      {
        "title": "Ako je zaistená diskrétnosť?",
        "bodyText": "Vaša otázka, krstné meno a&nbsp;vek vidí iba lekár, ktorý vám odpovedá. K&nbsp;ďalším informáciám uvedeným v&nbsp;rámci vašej požiadavky má prístup iba zdravotnícky tím. Vaše otázky nie sú ďalej s&nbsp;nikým zdieľané.<br/><br/> V&nbsp;prípade, že prikladáte lekársku správu či iný dokument, odporúčame najprv začierniť viditeľné osobné údaje a&nbsp;až potom prílohu nahrať k&nbsp;otázke, aby bola dodržaná úplná anonymita aj&nbsp;z&nbsp;vašej strany."
      },
      {
        "title": "Na webe uLekára.sk sú ale otázky zobrazené, budú tam aj moje?",
        "bodyText": "NEBUDÚ, otázky držiteľov prémiovej či firemnej karty Mastercard<sup>®</sup> nie sú na stránkach zverejňované."
      },
      {
        "title": "Je využitie služby bezpečné?",
        "bodyText": "ÁNO, je. Služba je v&nbsp;súlade so&nbsp;všeobecným nariadením ochrany osobných údajov tzv.&nbsp;GDPR. Všetky požiadavky sú riešené len medzi vami a&nbsp;určenými osobami služby uLekára.sk, prípadne zvoleným zdravotníckym zariadením."
      }
    ]
  },
  "preventionForm": {
    "title": "Povedzte nám o sebe viac",
    "subtitle": "Ak by naši lekári usúdili, že je potrebné váš zdravotný problém riešiť návštevou lekára, potrebujeme o vás poznať ďalšie informácie.",
    "birthDate": {
      "title": "Dátum narodenia",
      "helpText": "Dátum narodenia uveďte v tvare deň, mesiac, rok, napr. 21.1.1999",
      "errorText": "Vyplňte dátum narodenia.",
      "errorTextDate": "Dátum narodenia nie je v správnom formáte.",
      "errorTextBirthDateRange": "Uveďte správny dátum narodenia."
    },
    "gender": {
      "title": "Pohlavie",
      "selectGender": "Vyberte pohlavie",
      "errorText": "Vyberte pohlavie.",
      "male": "Muž",
      "female": "Žena",
      "other": "Iné"
    },
    "language": {
      "title": "Jazyk",
      "selectLanguage": "Vyberte jazyk pre komunikáciu",
      "errorText": "Vyberte jazyk pre komunikáciu."
    },
    "preventiveCheckUp": {
      "title": "Preventívne prehliadky a očkovanie",
      "examinationTitle": "Prosím, vyberte <strong>zdravotné prehliadky</strong>, ktoré ste absolvovali (nepovinné):",
      "examinationDate": "Kedy ste vyšetrenie naposledy absolvoval?",
      "vaccinationDate": "Kedy ste očkovanie naposledy absolvoval/a?",
      "examinationsSubtitle": "Boli súčasťou poslednej kontroly tieto vyšetrenia?",
      "vaccinationTitle": "Prosím, vyberte <strong>očkovanie</strong>, ktoré ste absolvovali (nepovinné):",
      "nameExamination": "Názov vyšetrenia",
      "examinationSelectBtn": "Vyberte zdravotné prehliadky zo zoznamu",
      "vaccinationSelectBtn": "Vyberte očkovanie zo zoznamu.",
      "dateRange": {
        "range_1": "Tento rok",
        "range_2": "Vlani",
        "range_3": "Predvlani",
        "range_4": "Nepamätám si",
        "range_5": "Nikdy"
      },
      "otherTitle": "Názov vyšetrenia",
      "selectYear": "Zadajte rok",
      "iAmNotSure": "Nepamätám si"
    },
    "address": {
      "title": "Adresa (nepovinné)",
      "placeholder": "Zadajte polohu"
    },
    "registeredModal": {
      "title": "Ďakujem",
      "subtitle": "Vaša registrácia do preventívneho programu už prebehla."
    }
  },
  "ulekareContacts": {
    "email": "info@ulekara.sk",
    "phone": "+421&nbsp;950&nbsp;105&nbsp;650",
    "hours": "Po–Pi 8–17&nbsp;h"
  },
  "authorizationPage": {
    "successText": "Úspešne sme overili, že máte nárok na službu zadarmo.",
    "prevention": {
      "title": "Ďakujeme. Autorizácia prebehla úspešne.",
      "subtitle": "Kliknite na odkaz zaslaný na e-mail <strong class=\"text-primary\">{email}</strong>."
    }
  },
  "verification": {
    "title": "Prihlásenie k preventívnemu programu prebehla úspešne.",
    "subtitle": "Ďakujeme za overenie e-mailu."
  },
  "renewPassword": {
    "title": "Obnovenie hesla",
    "setPassword": "Vytvorte heslo",
    "setPasswordAgain": "Zadajte heslo znova",
    "newPassword": "Nové heslo",
    "changePassword": "Zmeniť heslo",
    "minLengthError": "Heslo musí mať minimálne 5 znakov.",
    "requiredErrorText": "Pole je povinné",
    "generatedError": {
      "start": "Heslo musí",
      "minLength": "mať minimálnu dĺžku {length} znakov",
      "and": "a",
      "require": "obsahovať",
      "oneChar": "písmeno",
      "oneNumber": "číslo",
      "specialChar": "špeciálny znak"
    },
    "sameAsPasswordErrorText": "Heslá sa nezhodujú.",
    "successMessage": "Heslo bolo úspešne zmenené.",
    "invalidToken": {
      "title": "Odkaz nie je platný.",
      "perex": "Vygenerujte si nový odkaz kliknutím na \"zabudnuté heslo\" v mobilnej aplikácii uLékaře.cz."
    },
    "usedToken": {
      "perex": "Tento odkaz už nie je platný, pretože už bol raz použitý."
    },
    "expiredToken": {
      "title": "Odkazu vypršala platnosť.",
      "perex": "Vygenerujte si nový odkaz kliknutím na \"zabudnuté heslo\" v mobilnej aplikácii uLékaře.cz."
    },
    "nextButton": "Přihláste sa do {service}"
  },
  "emailVerification": {
    "successMessagePerex": "Váš e-mail sme úspešne overili. Môžete sa prihlásiť.",
    "button": "Pokračujte na {service}",
    "invalidToken": "Odkaz nie je platný.",
    "usedToken": "Tento odkaz už nie je platný, pretože už bol raz použitý.",
    "expiredToken": "Odkazu vypršala platnosť."
  },
  "partnerNavigation": {
    "hello": {
      "title": "Ako začať využívať službu uLekára.sk",
      "items": [
        {
          "icon": "compass",
          "text": "Prihláste sa alebo si založte účet."
        },
        {
          "icon": "glasses",
          "text": "Následne môžete začať využívať našu službu."
        }
      ]
    },
    "helloHrb": {
      "title": "Využite službu uLekára.sk.",
      "items": [
        {
          "icon": "compass",
          "text": "Nájdite svojho zamestnávateľa podľa názvu firmy."
        },
        {
          "icon": "glasses",
          "text": "Vyberte službu, ktorú chcete využiť."
        }
      ]
    },
    "partnerSignpost": {
      "title": " ",
      "subtitle": "Kto hradí službu?",
      "text": "Službu môžete mať zadarmo ako benefit od svojho zamestnávateľa, mesta, kartovej spoločnosti, neziskovej organizácie a ďalších firiem. Zaregistrujte sa a prejdite do sekcie správa benefitu, kde si vyberiete svojho zamestnávateľa"
    },
    "tabs": [
      "Iný benefit",
      "Mastercard<sup>®</sup>"
    ],
    "employer": {
      "title": "Nájdite svojho zamestnávateľa podľa názvu.",
      "searchPlaceholder": "Zadajte názov firmy"
    },
    "results": {
      "noResultStart": "Váš zamestnávateľ tu nie je?",
      "noResultContact": "Kontaktujte nás",
      "noResultMiddle": "alebo si",
      "noResultReadMore": "prečítajte o službe viac",
      "noResultEnd": "."
    },
    "partnerTypes": [
      {
        "boxTitle": "Mám službu od zamestnávateľa"
      },
      {
        "buttonText": "Vybrať",
        "title": "Kliknite na logo svojej poisťovne.",
        "boxTitle": "Mám službu od poisťovne",
        "partnerGtmAction": "Klik Přechod na pojišťovnu",
        "boxes": [
          {
            "gtmLabel": "VoZP",
            "isExternalLink": "true",
            "image": "partner-vozp.png",
            "link": "kp.vozp.cz"
          },
          {
            "gtmLabel": "OZP",
            "isExternalLink": "true",
            "image": "partner-ozp.png",
            "link": "www.ozp.cz/vkol"
          }
        ]
      },
      {
        "buttonText": "Prejsť na službu",
        "title": "Kliknite na logo pre využitie služby uLekára.sk.",
        "boxTitle": "Mám službu od Mastercard",
        "partnerGtmAction": "Klik Mastercard box",
        "boxes": [
          {
            "gtmLabel": "Mastercard",
            "isExternalLink": "false",
            "image": "logos/mc_logo.png",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "mastercard"
              }
            }
          }
        ]
      },
      {
        "buttonText": "Vybrať",
        "title": "Kliknite na logo svojho partnera.",
        "boxTitle": "Mám službu ako benefit",
        "partnerGtmAction": "Klik Přechod na partnera",
        "boxes": [
          {
            "gtmLabel": "Fairsurence",
            "image": "partner-fairsurence.png",
            "isExternalLink": "false",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "spolekpromaterstvi"
              }
            }
          }
        ]
      }
    ],
    "video": {
      "title": "Nikdy nemáme zatvorené a nemusíte klopať."
    }
  },
  "unsupportedBrowser": {
    "title": "Váš prehliadač nie je podporovaný",
    "perex": "Ľutujeme, ale momentálne používate starší internetový prehliadač, ktorý nie je našou službou plne podporovaný, teda nie je možné službu naplno využiť. Pre využitie služby, prosíme použite jeden z nasledujúcich podporovaných prehliadačov, prípadne vykonajte aktualizáciu."
  },
  "login": {
    "banner": {
      "title": "Vaše dáta zostanú v bezpečí.",
      "subtitle": "Neustále zlepšujeme naše služby, aby vaše dáta boli len vaše. To je naša priorita."
    },
    "socials": {
      "facebook": "Prihlásiť sa cez Facebook",
      "google": "Prihlásiť sa cez Google",
      "apple": "Prihlásiť sa cez Apple"
    },
    "title": "Prihlásiť sa",
    "subtitle": "Na využitie služieb uLekára.sk sa prihláste",
    "loginError": "Neplatné prihlasovacie údaje. Skúste to znova.",
    "forgetPassword": "Zabudnuté heslo?",
    "password": {
      "title": "Heslo",
      "requiredError": "Heslo je povinné"
    },
    "remember": "Zapamätať užívateľa",
    "login": "Prihlásiť sa",
    "noAccount": "Ešte nemáte účet?",
    "registration": "Zaregistrujte sa.",
    "registrationHeaderButton": "Zaregistrujte sa"
  },
  "registration": {
    "title": "Registrácia",
    "subtitleFirstStep": "Na využitie služieb uLekára.sk je nutné sa registrovať",
    "subtitle": "Uvedené údaje slúžia pre komunikáciu so zdravotným týmom uLekára.sk.",
    "addData": {
      "title": "Doplnenie údajov",
      "subtitle": "Vaše prihlásenie je úspešné, ale potrebujeme aktualizovať údaje na komunikáciu zo zdravotným týmom uLekára.sk"
    },
    "emailError": "E-mail už máte v uLekára.sk registrovaný.",
    "email": {
      "errorEmailNotExisting": "Vyplňte existujúcu e-mailovú adresu.",
      "errorInvalidDomain": "Nepovolené email doména, použite iný email.",
      "errorText": "Chýba e-mail.",
      "title": "Osobný e-mail"
    },
    "socials": {
      "facebook": "Registrovať cez Facebook",
      "google": "Registrovať cez Google",
      "apple": "Registrovať cez Apple"
    },
    "loginText": {
      "link": "Prihláste sa",
      "suffix": ", prosím.",
      "question": "E-mail bol už pre registráciu použitý."
    },
    "login": {
      "text": "Už máte účet?",
      "link": "Prihláste sa."
    },
    "finishRegistration": "Dokončiť registráciu",
    "legal": {
      "text": "Súhlasím s {termsAndConds}.",
      "termsConditions": "podmienkami užitia",
      "privacyPolicy": "Zásadami ochrany osobných údajov."
    }
  },
  "missingProfileData": {
    "title": "Doplnenie údajov",
    "titleLegal": "Potvrdenie súhlasov",
    "text": "Z prepojeného účtu sa nám nepodarilo získať vašu e-mailovú adresu, ktorú potrebujeme na poskytnutie našich služieb. Doplňte ju prosím nižšie.",
    "textLegal": "Potvrďte, prosím, nasledujúce:"
  },
  "phoneVerification": {
    "title": "Overenie telefónneho čísla",
    "subtitle": "Na vaše telefónne číslo {phone} sme zaslali overovací kód v SMS. Zadajte ho prosím nižšie.",
    "label": "Kód z SMS",
    "changeNumber": "Zmeniť číslo",
    "inputError": "Kód je povinný",
    "codeError": "Zadaný kód nie je platný. Potrebujete poradiť?",
    "sendAgain": "Poslať kód znova",
    "verify": "Overiť",
    "error": {
      "error_timeout": {
        "title": "Počkajte prosím na overovaciu SMS",
        "perex": "Zaznamenali sme opakované požiadavky na zmenu telefónneho čísla. Prosím počkajte, aby sme predišli odoslaniu veľkého počtu správ."
      },
      "error_block": {
        "title": "Váš učet bol dočasne zablokovaný",
        "perex": "Overenie telefónneho čísla bolo pozastavené kvôli podozrivej aktivite. Z bezpečnostných dôvodov sme váš účet dočasne zablokovali. Obráťte sa prosím na našu zákaznícku starostlivosť",
        "callUs": "Zavolajte nám",
        "writeUs": "Napíšte nám"
      }
    }
  },
  "phoneChange": {
    "title": "Zmena telefónneho čísla",
    "sendCode": "Poslať kód"
  },
  "lostPassword": {
    "title": "Zabudnuté heslo",
    "subtitle": "Odkaz pre obnovenie hesla dostanete v případe, že ste týmto e-mailom registrovaný na našom webe alebo v mobilnej aplikácií.",
    "button": "Obnoviť heslo.",
    "linkSentTitle": "Odoslané",
    "linkSentPerex": "E-mail pre obnovenie hesla bol odoslaný na {email}. Pokiaľ ho vo svojom e-maile nenájdete, pozrite sa do zložky „SPAM“.",
    "sendLinkAgain": "Poslať e-mail znova",
    "finishRegistration": "Dokončiť registráciu"
  },
  "profileSection": {
    "menu": {
      "profile": "Môj účet",
      "subscription": "Predplatné",
      "logout": "Odhlásiť sa"
    },
    "badge": {
      "self": "samoplatiteľ",
      "premium": "hradené"
    },
    "freeService": {
      "title": "Služba zadarmo",
      "text": "Služba je často hradená partnermi, zamestnávateľmi a poisťovňami.",
      "button": "Mám nárok?"
    },
    "thankYou": "Službu vám hradí {partnerName}",
    "thankYouHost": "Službu zadarmo zdieľa {host}"
  },
  "dashboard": {
    "menu": {
      "home": "Prehľad",
      "questions": "Poradňa",
      "appointments": "Objednávky",
      "prevention": "Prevencia",
      "explore": "Články"
    },
    "personalInfoAssurance": {
      "prefix": "Ako s vami budeme komunikovať?",
      "email": "E-mail",
      "phone": "Telefón"
    },
    "deactivatedUser": "<strong>Váš účet bol deaktivovaný.</strong> <span class=\"black--text\">Ak sa domnievate, že neoprávnene, kontaktujte nás: <a href=\"mailto:{email}\">{email}</a> alebo tel. {phone}.</span>",
    "title": "Zdravíme vás! 👋",
    "subtitle": "Ako vám môžeme pomôcť?",
    "needAdvice": "Napísať otázku",
    "needAppointment": "Chcem objednať",
    "needHelp": "Potrebujete poradiť?",
    "supportBox": {
      "openTitle": "Dôležité kontakty",
      "title": "Zákaznícka podpora",
      "boxText": "Sme tu pre vás, nech už potrebujete pomoc s čímkoľvek",
      "chat": {
        "title": "Zákaznický chat",
        "textOnline": "Sme online <br /> Nech už máte akúkoľvek otázku alebo problém, ktorý nie je medicínsky. Sme tu pre vás.",
        "textOffline": "Sme offline <br /> Sme online od 8:00 do 17:00 (Po-Pia)",
        "button": "Spustit chat",
        "icon": "chat"
      },
      "customerService": {
        "title": "Zákaznická linka",
        "subtitle": "8:00 - 17:00 (Po-Pia)",
        "buttonEmail": {
          "text": "info@ulekara.sk",
          "subtitle": "Kontaktný e-mail:"
        },
        "buttonPhone": {
          "text": "+421 950 105 650",
          "subtitle": "Platená linka:"
        },
        "linkEmail": "mailto:info@ulekara.sk",
        "linkPhone": "tel:+421 950 105 650",
        "icon": "care",
        "tescoButtonPhone": {
          "text": "+421 800 232 007",
          "subtitle": "Bezplatná linka:"
        },
        "tescoLinkPhone": "tel:+421 800 232 007",
        "tescoButtonPhonePaid": "Platená linka  +421 950 105 650",
        "tescoLinkPhonePaid": "tel:+421 950 105 650"
      },
      "assistanceService": {
        "title": "SOS psychická pomoc",
        "subtitle": "Psychologické poradenstvo",
        "buttonEmail": "info@e-a.cz",
        "buttonPhone": "+421 950 105 650",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+421 950 105 650",
        "icon": "happy"
      },
      "covidService": {
        "title": "Covid infolinka",
        "button": "+421 950 105 650",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+421 950 105 650",
        "icon": "lungs"
      },
      "unavailableOn": "Upozorňujeme, že zákaznícka podpora a služba sprievodca zdravím budú v deň {date} k dispozícii v obmedzenom režime. Vysporiadanie zaslaných požiadaviek sa môže oneskoriť. V prípade všeobecných otázok nám prosím napíšte na uvedenú e-mailovú adresu. \nĎakujeme za pochopenie.",
      "outageDateISO": "2026-04-09"
    },
    "freeService": "Mám službu zadarmo?",
    "requestSent": "Dokončite aktiváciu v pracovnom e-maile",
    "hint": {
      "subtitle": "chirurg, spoluzakladateľ uLekára.sk",
      "text": "„Vybavte si všetko rýchlo v pohodlí svojho domova alebo z pracoviska.<br/>Potrebujete poradiť? Rád vám pomôžem ja alebo niekto z mojich 350 kolegov.\""
    },
    "questions": {
      "myQuestions": "Moje otázky",
      "updated": "Máme pre vás odpoveď!",
      "resolvers": "Starajú sa o vás",
      "sla": "Odpovieme už do <strong class=\"black--text\">{hour}</strong> h."
    },
    "appointments": {
      "myAppointments": "Moje objednávky"
    },
    "videoCall": {
      "buttonText": "Naplánovať videohovor",
      "buttonTextMobile": "Videohovor"
    },
    "services": {
      "question": {
        "title": "Poradňa (24/7)",
        "subtitle": "s&nbsp;odpoveďou do&nbsp;{hours}&nbsp;h",
        "b2cSufix": "za&nbsp;{priceCzk}&nbsp;Kč (cca&nbsp;{priceEur}&nbsp;€)",
        "text": "Praktickí lekári a špecialisti sú tu pre vás na jednom mieste.",
        "button": "Potrebujem poradiť"
      },
      "videoCall": {
        "title": "Videohovor",
        "subtitle": "s lekárom",
        "text": "Lekári sa vám na videohovore venujú až 20 minút vo vami vybraný čas.",
        "button": "Naplánovať videohovor"
      },
      "appointment": {
        "title": "Sprievodca zdravím",
        "subtitle": "po celej SR",
        "text": "Sestry vás nasmerujú k riešeniu.",
        "button": "Zadať požiadavku"
      },
      "prevention": {
        "title": "Prevencia",
        "subtitle": "Zdravie vo vašich rukách",
        "text": "Postarajte sa s našou podporou čo najlepšie o svoje zdravie",
        "existedButton": "Vstúpiť do prevencie"
      },
      "thematic_counseling": {
        "title": "Tématické poradne",
        "text": "Využite naše poradne zamerané na konkrétne témy. Spýtajte sa odborníkov na to, čo vás zaujíma.",
        "button": "Vybrať tému"
      },
      "hints": {
        "service_not_supported_in_this_language": {
          "text": "Službu nie je možné využívať v {language}. Na využitie služby zvoľte v nastavení <a href=\"{link}\" class=\"link--inline\">svojho profilu</a> iný jazyk služby.",
          "cs": "češtine",
          "en": "angličtine",
          "sk": "slovenčine"
        }
      }
    },
    "news": "Novinky",
    "recomended": "Odporúčané pre vás",
    "emailVerification": {
      "title": "Overenie e-mailovej adresy",
      "subtitle": "Prejdite do svojej e-mailovej schránky <strong>{email}</strong> a kliknite na overovací odkaz v e-maile, ktorý sme vám zaslali.",
      "text": [
        {
          "title": "Nedostali ste správu?",
          "list": [
            {
              "icon": "check_circle",
              "text": "Skontrolujte zložku nevyžiadanej pošty (spam)"
            },
            {
              "icon": "check_circle",
              "text": "Počkajte niekoľko minút a potom skúste poslať e-mail znovu"
            }
          ]
        },
        {
          "text": "Prosíme začnite registráciu znovu"
        }
      ],
      "actions": {
        "right": {
          "type": "resend",
          "baseText": "Poslať e-mail znova"
        }
      }
    },
    "help": {
      "text": "Neviete si rady?",
      "hours": "Po-pi 8–17 h"
    }
  },
  "videoCall": {
    "infoStep": {
      "title": "Online sedenie s lekárom",
      "perex": "Dohovorte si termín videohovoru a preberte s lekárom akýkoľvek zdravotný problém, aj bez návštevy ordinácie.",
      "list": {
        "first": "Uistite sa, že máte vyplnené základné údaje a overené telefónne číslo.",
        "second": "Vyberte dátum a čas, ako vám vyhovuje. Hovor stihnete aj počas obedovej pauzy.",
        "third": "V dohodnutý čas sa pripojíte k videohovoru. Lekár sa venuje 20 minút iba vám."
      },
      "legal": [
        "Službu vám sprostredkujeme u poskytovateľa zdravotných služieb, ktorým je spoločnosť:",
        "uLékaře.cz Health Care, s.r.o.<br/>so sídlom Českomoravská 1a, 190&nbsp;00&nbsp;Praha&nbsp;9 IČO:&nbsp;096&nbsp;64&nbsp;777<br/>vedená na&nbsp;Mestskom súde v&nbsp;Prahe pod sp.&nbsp;zn.&nbsp;C&nbsp;339989",
        "Zdravotná služba Videohovor s lekárom nie je hradená z verejného zdravotného poistenia. Náklady na&nbsp;ňu hradí váš zamestnávateľ.",
        "Videohovor s lekárom je zdravotná služba poskytovaná na diaľku formou videohovoru s lekárom, a to len v oblasti internej medicíny."
      ],
      "button": "Vybrať termín videohovoru"
    },
    "formStep": {
      "title": "Skontrolujte základné údaje",
      "legal": {
        "termsConditions": {
          "text": "Súhlasím s {legalText} Videohovor s lekárom poskytovateľa zdravotných služieb uLékaře.cz Health Care, s.r.o.",
          "legalText": "podmienkami poskytnutia služby"
        },
        "personalData": {
          "text": "Vaše osobné údaje spracovávame v súlade so {link}.",
          "legalText": "Zásadami ochrany osobných údajov"
        }
      }
    },
    "iframeStep": {
      "title": "Vyberte si termín"
    }
  },
  "tally": {
    "anxiety": {
      "infoStep": {
        "button": "Vyplniť dotazník"
      }
    },
    "depression": {
      "dashboardBox": {
        "title": "Test rizika depresie",
        "text": "Je to zlá nálada, alebo depresia? Otestujte sa.",
        "button": "Vyplniť dotazník"
      },
      "infoStep": {
        "title": "Zlá nálada, alebo depresia?",
        "timeApproximation": "~2 minúty",
        "perex": "Cítite sa v poslednom čase vyčerpaní, bez energie a nič vás neteší? Online test rizika depresie vám pomôže zmapovať vaše pocity.",
        "list": [
          "Vyberte odpovede, ktoré najlepšie zodpovedajú vašej súčasnej situácii.",
          "Obratom uvidíte svoj výsledok vrátane praktických odporúčaní."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychológia",
          "workplace": "Psychologička z uLekára.sk"
        },
        "button": "Vyplniť dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/npkN0E",
        "b2c": ""
      }
    },
    "liver": {
      "dashboardBox": {
        "title": "Test zdravej pečeně",
        "text": "Otestujte sa, ako dobre sa staráte o svoju pečeň.",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Dobre sa staráte o svoju pečeň?",
        "timeApproximation": "~3 minúty",
        "perex": "Tento krátky test vám prezradí, ako je na tom vaša pečeň a či potrebuje viac starostlivosti ako doteraz.",
        "list": [
          "Vyberte odpovede, ktoré považujete za správne a hodia sa k vášmu zdraviu.",
          "Obratom uvidíte svoj výsledok vrátane praktických odporúčaní."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mjr. MUDr. Denisa Gottvaldová z uLekára.sk",
          "specialization": "Praktické lékařství pro dospělé",
          "workplace": "Centrum zdravotních služeb Bechyně"
        },
        "button": "Vyplniť test"
      },
      "urls": {
        "b2b": "https://tally.so/r/wavLZZ"
      }
    },
    "heart": {
      "dashboardBox": {
        "title": "Máte zdravé srdce?",
        "text": "Niekoľko otázok prezradí, čo potrebuje vaše srdce.",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Ako je na tom vaše srdce?",
        "timeApproximation": "~3 minúty",
        "perex": "Tento test napovie, či je vaše srdce v dobrom stave, alebo už bije na poplach.",
        "list": [
          "Odpovedzte za 3 minúty na desať krátkych otázok.",
          "Obratom uvidíte svoj výsledok vrátane praktických tipov."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Dr. Oleksii Bolotskykh",
          "specialization": "Kardiológia pre dospelých",
          "workplace": "Kardiologie na Bulovce, s.r.o."
        },
        "button": "Vyplniť test"
      }
    },
    "movement": {
      "infoStep": {
        "button": "Vyplniť test",
        "garant": {
          "workplace": "Súkromná prax YOTAI, Praha",
          "specialization": "Odborníčka na tanečnú a športovú medicínu",
          "name": "MgA. Klára Lidová, Ph.D.",
          "title": "Garant testu"
        },
        "list": [
          "Odpovedzte za 2 minúty na desať krátkych otázok.",
          "Obratom uvidíte svoj výsledok vrátane praktických odporúčaní."
        ],
        "perex": "Rýchly test prezradí, či sa dostatočne hýbete, alebo vaše telo volá po akcii.",
        "timeApproximation": "~2 minúty",
        "title": "Máte dostatok pohybu?"
      },
      "dashboardBox": {
        "button": "Vyplniť test",
        "text": "Otestujte si svoju kondíciu krátkym online testom.",
        "title": "Pohyb a vy"
      }
    },
    "imunity": {
      "dashboardBox": {
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Máte silnú imunitu?",
        "timeApproximation": "~2 minúty",
        "perex": "Otestujte, či vaša imunita funguje ako štít, alebo ju porazí každá choroba.",
        "list": [
          "Odpovedzte za 2 minúty na osem krátkych otázok.",
          "Obratom uvidíte svoj výsledok vrátane praktických tipov."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "MUDr. Jana Emlerová",
          "specialization": "Alergiológ a klinický imunológ",
          "workplace": "Alergiológia a klinická imunológia GENNET"
        },
        "button": "Vyplniť test"
      }
    },
    "circulation": {
      "dashboardBox": {
        "button": "Vyplniť test"
      },
      "infoStep": {
        "timeApproximation": "~2 minúty",
        "garant": {
          "title": "Garantka testu"
        },
        "button": "Vyplniť test"
      }
    },
    "flexibility": {
      "dashboardBox": {
        "button": "Vyplniť test"
      },
      "infoStep": {
        "timeApproximation": "~2 minúty",
        "garant": {
          "title": "Garantka testu"
        },
        "button": "Vyplniť test"
      }
    }
  },
  "profileAuthorization": {
    "chooseSubscription": "Zvoliť predplatné",
    "language": {
      "title": "Nastavenie služby",
      "text": "Vyberte si, v ktorom jazyku chcete službu uLekára.sk využívať.",
      "errorText": "Aktuálny jazyk nie je podporovaný plátcom služby. Vyberte iný jazyk."
    },
    "final": {
      "title": "Registrace prebehla úspešne",
      "text": "Teraz môžete využívať službu uLekára.sk. Naši lekári a zdravotné sestry sú tu pre vás."
    },
    "possiblePartners": {
      "title": "Zdá sa, že máte nárok na službu zadarmo",
      "textHrb": "Potvrďte jedného z nižšie uvedených zamestnavateľov alebo partnerov, ktorý službu hradia. Nemôžete si vybrať? Zmeňte partnera.",
      "changePartner": "Zmeniť partnera"
    },
    "hrbPartner": {
      "title": "Aktivácia služby zadarmo",
      "textBoth": "Pre aktiváciu zadajte firemný e-mail alebo aktivačný kód, ktorý ste obdržali od {partner}.",
      "textEmail": "Pre aktiváciu zadajte firemný e-mail.",
      "textCode": "Pre aktiváciu zadajte aktivačný kód, ktorý ste dostali od {partner}.",
      "tabs": [
        "E-mailom",
        "Kódom"
      ],
      "email": "Firemný e-mail",
      "code": "Aktivačný kód",
      "codeError": "<strong>Tento kód je bohužiaľ neplatný.</strong><br>Správnosť kódu si overte na svojom HR oddelení.<br>Ak je kód správny, radi vám pomôžeme na",
      "emailError": "Neplatný e-mail. Neviete si rady? Kontaktujte nás:  <a href=\"mailto:info@ulekara.sk\">info@ulekara.sk</a>.",
      "invalidEmployeeEmail": "E-mail nie je povolený pre zvoleného zamestnávateľa/partnera.",
      "benefitBlocked": "E-mail bol použitý u iného zamestnávateľa/partnera, aktivácia nie je možná."
    },
    "emailAuthorization": {
      "title": "Žiadosť o aktiváciu služby zadarmo odoslaná",
      "subtitle": "Na <strong class=\"black--text\"> {email} </strong> sme poslali aktivačný e-mail. Kliknutím na odkaz v e-maile službu zadarmo aktivujete.",
      "text": [
        {
          "title": "Neprišiel e-mail?"
        },
        {
          "title": "Uviedli ste nesprávny e-mail?",
          "link": {
            "type": "router",
            "routerAction": "replace",
            "name": "dashboard",
            "query": {
              "a_step": "authorization"
            },
            "textBefore": "Zmeňte to",
            "text": "tu"
          }
        }
      ],
      "actions": {
        "left": {
          "type": "resend",
          "class": "light",
          "baseText": "Poslať e-mail znova"
        },
        "right": {
          "type": "continue"
        }
      }
    },
    "authorizationSignpost": {
      "title": "Kto hradí službu?",
      "text": "Majte služby uLekára.sk zadarmo! Možno vám ju hradí zamestnávateľ alebo niekto z našich partnerov (poisťovne, kartové spoločnosti atď.).",
      "employees": "Zamestnávateľ",
      "search": "Hľadajte zamestnávateľa podľa názvu",
      "searchSignText": "Začnite písať názov firmy, v ktorej pracujete. Spoločne ju nájdeme.",
      "searchEmpty": {
        "title": "Pod výrazom “{text}” sa nám nepodarilo nič nájsť",
        "text": "Pokiaľ si myslíte, že by daná spoločnosť nemala v zozname chýbať, môžete nám ju {email}.",
        "emailText": "odporučiť"
      },
      "selfPay": "Službu hradím sám"
    },
    "selfPay": {
      "title": "Službu hradím sám",
      "text": "Ako samoplatca máte k dispozícii:",
      "price": "{priceCzk} Kč (cca {priceEur} €)",
      "priceSufix": "/dotaz",
      "list": [
        {
          "icon": "doctor",
          "text": "Odpoveď lekára do 8 hodín"
        },
        {
          "icon": "shield",
          "text": "Personalizovaný preventívny program"
        },
        {
          "icon": "news",
          "text": "Užitočné zdravotné tipy a články"
        }
      ]
    },
    "mastercard": {
      "title": "Overte si svoju kartu Mastercard<sup>®</sup>",
      "codeInvalidError": "Zadané číslo nie je validné. Skontrolujte, že zadávate 6 čísel svojej prémiovej či firemnej karty Mastercard<sup>®</sup>.",
      "label": "Prvých 6 číslic karty"
    },
    "external": {
      "titleSlot": "Nepodarilo sa nám overiť využitie služby zadarmo.",
      "vozpText": "Ako klient VoZP sa prihláste do klientského portálu VoZP a kliknite na logo uLékaře.cz. Po prvom prihlásení vám budú sprístupnené všetky naše služby.",
      "ozpText": "Klientom OZP je služba uLékaře.cz prístupná 24/7 cez VITAKARTU. Prihláste sa prosím do svojho účtu VITAKARTY.",
      "drmaxText": "Ako klient Dr. Max sa prihláste do Karty výhod a kliknite na logo uLékaře.cz.",
      "mcText": "Potrebujeme overiť prvých 6 čísel vašej karty MasterCard<sup>®</sup> Premium. Nejedná sa o platbu, po úspešnom zadaní budete môcť využiť služby uLékaře.cz zadarmo.",
      "fairsuranceText": "Pre aktiváciu služby zadarmo, prosím zadajte autorizačný kód, ktorý ste dostali z Fairsurance.",
      "sporthelpText": "{title}Pre aktiváciu služby zadarmo pre členov športového poistenia SportHelp kliknite na odkaz pre využitie služby, ktorý nájdete vo svojej digitálnej členskej karte v sekcii Lekárska poradňa uLékaře.cz.",
      "defaultErrorText": "Autorizačný odkaz už nie je možné použiť, pretože jeho platnosť vypršala. Ďakujeme vám za pochopenie."
    },
    "chooseDifferentCompany": "Zmeniť partnera"
  },
  "profile": {
    "title": "Môj účet",
    "titleMobile": "Nastavenia",
    "subtitle": "Vyplňte všetky údaje a nastavte si využitie služby podľa seba.",
    "basicData": "Základné údaje",
    "emailNote": "Zmena e-mailovej adresy nie je možná, je potrebné registrovať sa znova s novou e-mailovou adresou.",
    "phoneNote": "Na tomto čísle vás môžu kontaktovať naše sestričky pri riešení vašich požiadaviek.",
    "security": "Zabezpečenie",
    "currentPassword": "Pôvodné heslo",
    "invalidCurrentPassword": "Neplatné pôvodné heslo",
    "currentPasswordUsedInHistory": "Nové heslo nesmie byť rovnaké ako staré.",
    "newPassword": "Nové heslo",
    "additionalInfo": "Doplňujúce údaje",
    "birthDateNote": "Podľa vašeho veku sa lekár lepšie vyjadrí.",
    "address": "Adresa",
    "addressNote": "Podľa adresy vám odporučíme, kam sa objednať.",
    "family": "Moja rodina",
    "aboutApp": "O aplikácii",
    "applicationLock": "Zámok aplikácie",
    "moreOptions": "Ďalšie možnosti",
    "healthInsuranceProvider": {
      "title": "Zdravotná poisťovňa",
      "note": "Nájdeme lekára spolupracujúceho s vašou poisťovňou."
    },
    "applicationLanguage": {
      "title": "Jazyk aplikácie",
      "message": "V tomto jazyku se bude zobrazovať web"
    },
    "serviceLanguage": {
      "title": "Jazyk služby",
      "message": "V tomto jazyku vám bude odpovedať lekár"
    },
    "changeLanguageNotification": {
      "text": "Po uložení zmien sa jazyk webu zmení na",
      "cs": "češtinu",
      "en": "angličtinu",
      "sk": "slovenčinu",
      "uk": "ukrajinčinu",
      "ru": "ruštinu"
    },
    "storeMessage": {
      "success": "Zmeny sú uložené.",
      "error": "Zmeny sa neuložili. Skontrolujte prosím správnosť uvedených údajov.",
      "passwordError": "Zmeny sa neuložili z dôvodu zle zadaného pôvodného hesla."
    },
    "ucb": {
      "title": "Právne dokumenty a oznámenia",
      "text": "Vezmite prosím na vedomie, že UniCredit Bank Czech Republic and Slovakia, a.s. nepreberá žiadnu zodpovednosť za obsah a priebeh služby, ktorá je zamestnancovi poskytnutá. Využitie tejto služby zamestnancom je dobrovoľné a zodpovednosť za dodanie služby vo forme lekárskej rady nesie poskytovateľ služby spoločnosť uLékaře.cz, s.r.o., ktorá zodpovedá za to, že lekársku radu poskytuje výhradne osoba na to spôsobilá podľa platných právnych predpisov České republiky. Zamestnancovi sa odporúča pred využitím služby lekárskej poradne riadne sa oboznámiť s {terms_and_conditions}.",
      "termsAndConditions": "podmienkami použitia služby"
    },
    "removeSection": {
      "title": "Zrušenie účtu",
      "button": "Zrušiť účet"
    },
    "removeDialog": {
      "list": [
        {
          "icon": "chat-empty"
        },
        {
          "icon": "surgeon"
        },
        {
          "icon": "person-sad"
        }
      ],
      "cancelButton": "Nechcem si zrušiť účet"
    },
    "benefits": {
      "blood_tests_review": {
        "chip": "Krvné testy + vysvetlenie"
      }
    },
    "benefit": {
      "showMore": "Zobraziť viac"
    },
    "appSecurity": "Zabezpečenie aplikácie"
  },
  "passwordRenewal": {
    "title": "Aktualizujte si heslo.",
    "subtitle": "Je potrebné, aby ste si aktualizovali heslo, pretože platnosť vášho hesla vypršala.",
    "currentPassword": "Aktuálné heslo:",
    "newPassword": "Nové heslo:",
    "passwordRules": "Vaše heslo musí mať aspoň 8 znakov a obsahovať aspoň jedno písmeno, číslo a špeciálny znak(-=%*+./![]@#$^&()?;) a nesmiete použiť to isté heslo, ktoré ste použili v minulosti.",
    "confirmation": "Potvrdenie nového hesla",
    "passwordsDontMatch": "Heslá sa nezhodujú",
    "button": "Zmeniť heslo",
    "thankYouTitle": "Heslo bolo zmenené",
    "thankYouSubtitle": "Vaše heslo bolo úspešne zmenené. Ďakujeme vám za spoluprácu!"
  },
  "subscription": {
    "signpost": {
      "title": "Kto mi službu hradí?",
      "b2cButton": "Budem si ju hradiť sám",
      "b2bButton": "Zamestnávateľ alebo iná spoločnosť"
    }
  },
  "questions": {
    "title": "Poradňa",
    "subtitle": "Majte prehľad o svojich otázkach alebo sa spýtajte našich lekárov.",
    "noQuestion": {
      "title": "Ešte čakáme na vašu prvú otázku.",
      "subtitle": "S čím vám pomôžeme?",
      "infoList": [
        {
          "text": "Rýchlo sa dozviete, či sa s náhlym zdravotným problémom môžete poradiť sami alebo či je nutné vyhľadať lekársku pomoc.",
          "icon": "suitcase"
        },
        {
          "text": "Lekár z poradne vás nasmeruje na vhodné vyšetřenie alebo k správnemu špecialistovi.",
          "icon": "surgeon-question"
        },
        {
          "text": "Naši odborníci vám pomôžu zorientovať sa v lekárskej správe alebo laboratórnych výsledkoch.",
          "icon": "stop"
        },
        {
          "text": "Žiadne obavy, pomôžeme s riešením zdravotných problémov i vašim blízkym.",
          "icon": "temperature"
        }
      ]
    },
    "newQuestion": "Nová otázka",
    "newSolved": "V riešení",
    "waitingForAnswer": "Čakajú na odpoveď",
    "history": "História otázok",
    "detail": {
      "title": "Detail otázky",
      "sent": "Odoslané",
      "questionFormTitle": "Popis zdravotného problému",
      "healthFormTitle": "Zdravotný stav",
      "attachments": "Prílohy",
      "helped": "Pomohla vám odpoveď?"
    },
    "evaluation": {
      "title": "Ďakujeme za vašu reakciu",
      "text": "Pomáhate nám zlepšovať naše služby. Chcete nám zdeliť niečo ďalšieho?",
      "label": "Ďalšie komentáre a pripomienky",
      "placeholder": "Ako môžeme službu vylepšiť?",
      "ok": "Odpoveď mi pomohla",
      "nok": "Odpoveď mi nepomohla"
    },
    "thankYou": {
      "title": "Vaša otázka bola úspešne odoslaná",
      "subtitle": "(Služba bude doručovaná v {language} jazyku)",
      "cs": "českom",
      "en": "anglickom",
      "sk": "slovenskom",
      "text": "Teraz sa jej venuje praktický lekár a akonáhle odpovie na vaše otázky, upozorníme vás e- mailom."
    },
    "status": {
      "waitingGpAnswer": "Vaša otázka čaká na zodpovedanie praktickým lekárom.",
      "waitingSpecialistAnswer": "Vaša otázka čaká na zodpovedanie špecialistom.",
      "answered": "Vaša otázka je zodpovedaná.",
      "transferToAppointment": "Vaša otázka bola prevedená na objednávku. Budeme vás kontaktovať.",
      "declined": "Vaša otázka bola odmietnutá.",
      "emergency": "Vaša otázka je zodpovedaná. Môže sa jednať o život ohrozujúci stav, bezodkladne vyhľadajte najbližšiu pohotovosť."
    },
    "askedQuestions": "Položené dotazy"
  },
  "appointments": {
    "title": "Moje objednania",
    "subtitle": "Majte prehľad o vašich objednávkach. Požiadajte o vyhľadanie vhodného lekára.",
    "statuses": {
      "newDoctor": "Vyhľadali sme lekára.",
      "newZZ": "Vyhľadali sme zdravotnícke zariadenia."
    },
    "noAppointments": {
      "title": "Zatiaľ nemáte žiadne objednávky.",
      "subtitle": "Ako služba funguje?",
      "infoList": [
        {
          "text": "Vyplňte a odošlite svoju požiadavku.",
          "icon": "hospital"
        },
        {
          "text": "Nasledujúci pracovný deň vás kontaktuje zdravotná sestra, preberie s vami ďalší postup a pomôže vám nájsť riešenie.",
          "icon": "nurse"
        },
        {
          "text": "V rámci možností sa pokúsi overiť dostupnosť termínu vyšetrenia alebo vám pošleme overené kontakty na dostupných lekárov.",
          "icon": "clock"
        }
      ]
    },
    "newAppointment": "Nová požiadavka",
    "activeAppointments": "Aktivní objednávky",
    "visitAppointments": "Nezapomeňte navštívit lékaře",
    "evaluateAppointments": "Ohodnoťte návštěvu lékaře",
    "history": "História objednávok",
    "evaluation": {
      "ok": "Spokojnosť s návštevou",
      "nok": "Nespokojnosť s návštevou",
      "noVisit": "Návšteva lekára neprebehla"
    },
    "detail": {
      "title": "Detail objednávky",
      "sent": "Odoslaná",
      "date": "Termín objednania: ",
      "visitAt": "Kedy sa dostaviť: ",
      "facility": "Zdravotnícke zariadenie: ",
      "address": "Adresa: ",
      "doctor": "Lekár: ",
      "phone": "Telefón: ",
      "note": "Poznámka: ",
      "dateMandatory": "Vyššie uvedený termín je záväzný!",
      "unableToVisitInfo": "Ak sa na dohovorenú návštevu lekára nemôžete dostaviť, volajte prosím {phone} alebo píšte na <a href=\"mailto:{email}\">{email}</a>",
      "thankYou": "Veríme, že vám nami odporúčaný lekár pomôže v riešení vašich zdravotných problémov. Dajte nám prosím vedieť, či všetko dobre dopadlo. Ďakujeme!",
      "additionalQuestion": "Mám doplňujúcu otázku",
      "changeDate": "Zmeniť termín",
      "cancelAppointment": "Zrušiť požiadavku",
      "helped": "Ako hodnotíte službu?",
      "noVisit": "Neprebehla"
    },
    "thankYou": {
      "title": "Vaša objednávka bola úspešne odoslaná",
      "subtitle": "(Služba bude doručovaná v {language} jazyku)",
      "cs": "českom",
      "en": "anglickom",
      "sk": "slovenskom",
      "text": "Zdravotná sestra vás bude kontaktovať nasledujúci pracovný deň z čísla +421 950 105 650."
    },
    "status": {
      "waiting": "Vaša požiadavka čaká na spracovanie. Vyčkajte, ozveme sa vám.",
      "lookingForDoctor": "Pracujeme na vyhľadaní vhodného lekára.",
      "orderedForTime": "Vaša návšteva lekára je dohodnutá na {datetime} h.",
      "orderedForOpeningHours": "Požiadavka vybavená.",
      "sendContact": "Odoslaný kontakt na lekára.",
      "done": "Uzavreté",
      "cancelled": "Objednávka bola zrušená."
    }
  },
  "prevention": {
    "title": "Začnite s prevenciou. Zdravie je vaše.",
    "subtitle": "Vyplňte niekoľko údajov a získajte prevenciu na mieru. Pomôžeme vám predchádzať zdravotným obtiažam a ochoreniam.",
    "birthDateNote": "Vek je len číslo. My ho potrebujeme vedieť, aby sme vám poskytli správnu starostlivosť.",
    "healthInsuranceProviderNote": "Pre zobrazenie príspevkov poisťovne a objednávanie ku spolupracujúcim lekárom.",
    "personalization": {
      "banner": {
        "title": "Prevencia šitá na mieru",
        "subtitle": "Doplňte o sebe pár údajov a&nbsp;prevenciu vám ihneď prispôsobíme.",
        "button": "Získať prevenciu na mieru"
      },
      "title": "Personalizácia prehliadok dľa veku",
      "text": "Vypnutím sa zobrazia aj preventívne prehliadky, ktoré sa štandardne absolvujú v neskoršom veku."
    },
    "start": "Začať s prevenciou",
    "thankYou": {
      "title": "A je to! Ďakujeme za vyplnenie všetkých údajov.",
      "text": "Vďaka preventívnej starostlivosti môžete predchádzať zdravotným problémom a chorobám. Tipy a novinky týkajúce sa starostlivosti o zdravie nájdete pravidelne vo svojom e-maily."
    },
    "summary": {
      "title": "Prevencia",
      "subtitleDesktop": "Pomôžeme vám predchádzať zdravotným obtiažam a ochoreniam.",
      "subtitleMobile": "Predchádzajte zdravotným obtiažam.",
      "showAll": "Ukázať všetko",
      "intervalEnds": "Končiaci predpísaný interval",
      "planned": "Naplánované",
      "plannedOn": "Naplánované na {time}",
      "timeline": {
        "title": "Nasleduje",
        "tooltip": "Tu uvidíte najbližšie končiace predpísané intervaly prehliadok a očkovaní. Objednajte sa včas."
      },
      "examinations": {
        "title": "Preventívne prehliadky",
        "tooltip": "Uľahčíme vám orientáciu v informáciách a v termínoch vašich prehliadok."
      },
      "vaccinations": {
        "title": "Očkovanie",
        "tooltip": "Uľahčíme vám orientáciu v informáciách a v termínoch vašich očkovaní."
      },
      "others": {
        "title": "Ostatné"
      },
      "tallyTests": {
        "title": "Tematické zdravotné testy"
      }
    },
    "list": {
      "examinations": {
        "recommended": "Povinné prehliadky",
        "optional": "Dobrovoľné prehliadky"
      },
      "vaccinations": {
        "recommended": "Povinné očkovania",
        "optional": "Dobrovoľné očkovania"
      }
    }
  },
  "payment": {
    "title": "Vyberte platbu",
    "priceSum": "Celkom: {price} Kč",
    "voucher": "Kód vášho voucheru",
    "voucherGroup": "Poukaz {region}",
    "voucherApply": "Aplikovať",
    "pay": "Zaplatiť ({price} Kč)",
    "payment_created": "Platba zatiaľ nebola uhradená.",
    "payment_confirmed": {
      "title": "Dotaz odoslaný!",
      "subtitle": "Skvelé, váš dotaz je na ceste a čoskoro sa vám ozveme s odpoveďou na váš problém. Nebojte sa, všetko vyriešime! Dôverujte nám!"
    },
    "payment_canceled": "Platba bola zrušená.",
    "payment_rejected": "Vaša platba bola zamietnutá.",
    "payment_create_error": "Platba zlyhala. Skúste to znova.",
    "payment_timeouted": "Platba zlyhala. Skúste to znova.",
    "payment_in_progress": "Čakáme na uhradenie vašej platby.",
    "payment_wait": {
      "title": "Čakáme na overenie platby.",
      "subtitle": "Akonáhle bude platba overená, predáme dotaz lekárom."
    },
    "chooseDifferent": "Vyberte si iný spôsob"
  },
  "loginBanner": {
    "title": "Sme vašim sprievodcom na ceste za zdravím.",
    "infoList": [
      {
        "icon": "doctor",
        "text": "Praktický lekári a špecialisti odpovedajú na dotazy."
      },
      {
        "icon": "nurse",
        "text": "Sestry vás nasmerujú k riešeniu."
      },
      {
        "icon": "shield",
        "text": "Zabezpečené prostredie máte plne vo svojich rukách."
      }
    ],
    "show": "Ako služba funguje?",
    "hide": "Close"
  },
  "cookiesConsent": {
    "acceptAll": "Prijať všetko",
    "basic": {
      "title": "Náš web funguje ako lekár",
      "perex": "Náš web využíva súbory cookies, a funguje tak ako lekár, ktorý sa pýta, aby vám mohol čo najlepšie pomôcť. My takto zbierame {technical}, {analytical} a {marketing} informácie, aby sme sa mohli neustále zlepšovať, a lepšie tak pomáhať vám všetkým. Súhlasíte?",
      "technical": "technické",
      "analytical": "analytické",
      "marketing": "obchodné",
      "customize": "Nastavenie"
    },
    "settings": {
      "title": "Nastavenie súborov cookies",
      "description": "Pri návšteve našej webovej stránky www.ulekare.cz stránka získa alebo uloží informácie na vašom prehliadači, a to väčšinou vo forme súborov cookies. Môžu to byť informácie týkajúce sa vás, vašich preferencií a zariadení, ktoré používate. Väčšinou to slúži na vylepšovanie stránky, aby fungovala podľa vašich očakávaní. Informácie vás spravidla neidentifikujú ako jednotlivca, ale celkovo môžu pomôcť prispôsobovať prostredie vašim potrebám. Rešpektujeme vaše právo na súkromie, a preto sa môžete rozhodnúť, že niektoré súbory cookies nebudete akceptovať a to podľa voľby nižšie. Nezabúdajte ale na to, že zablokovaním niektorých súborov cookies môžete ovplyvniť, ako stránka funguje a aké služby sú vám ponúkané.",
      "link": "Prehlásenie o cookies nájdete {hereLink}.",
      "items": {
        "technical": {
          "title": "Technické cookies",
          "bodyText": "Sú nevyhnutné na to, aby naše stránky fungovali, takže nie je možné ich vypnúť. Väčšinou sú nastavené ako odozva na akcie, ktoré ste vykonali, ako je požiadavka služieb týkajúcich sa bezpečnostných nastavení, prihlasovanie, vyplňovanie formulárov atp. Prehliadač môžete nastaviť tak, aby blokoval súbory cookies alebo o nich posielal upozornenia. Tieto súbory cookies neukladajú žiadne identifikovateľné informácie."
        },
        "functional": {
          "title": "Funkčné cookies",
          "bodyText": "S týmito súbormi cookies je stránka výkonnejšia a osobnejšia. Môžeme ich nastavovať my alebo poskytovatelia tretej strany, ktorých služby na stránkach používame. Ak tieto súbory cookies nepovolíte, je možné, že niektoré alebo všetky tieto služby nebudú fungovať správne."
        },
        "analytics": {
          "title": "Analytické cookies",
          "bodyText": "Tieto súbory cookies slúžia na zlepšenie fungovania webových stránok. Umožňujú nám rozpoznať a zistiť počet návštevníkov a sledovať, ako používajú webové stránky. Pomáhajú nám zlepšovať spôsob, akým webové stránky fungujú. Tieto cookies nezhromažďujú informácie, ktoré by dokázali identifikovať vašu osobu."
        },
        "marketing": {
          "title": "Marketingové cookies",
          "bodyText": "Používajú sa na sledovanie preferencií používateľa webových stránok za účelom zacielenia reklamy, tj. zobrazenie marketingových a reklamných oznámení (aj na stránkach tretích strán) v súlade s týmito preferenciami. <strong>Marketingové súbory cookies využívajú nástroje externých spoločností. Tieto marketingové cookies budú použité iba na základe vášho súhlasu.</strong>"
        }
      },
      "save": "Uložiť nastavenia"
    },
    "youtube": {
      "text": "Na zobrazenie videa potrebujeme potvrdiť používanie cookies.Viac informácií nájdete {cookiePolicyLink}.",
      "cookiePolicyLinkText": "zásadách používania cookies",
      "accept": "Súhlasím"
    }
  },
  "thematic_counselling": {
    "dashboard": {
      "title": "Zaostrené na prevenciu",
      "hint": {
        "b2b": "Ako predchádzať nádorovým ochoreniam? {desktopBreakline}Ktoré preventívne vyšetrenia sú vhodné? Pýtajte sa.",
        "b2c": "Ako predchádzať nádorovým ochoreniam? {desktopBreakline}Ktoré preventívne vyšetrenia sú vhodné? Pýtajte sa zadarmo."
      },
      "onco-prevention": {
        "title": "Ako na onkologickú prevenciu?",
        "short": "Chceme vám pomôcť s obavami z vážnej choroby. S našimi lekármi je cesta k informáciám jednoduchá.",
        "long": "Bojíte sa, že máte v rodine zvýšené riziko vzniku rakoviny?<br>Ktoré preventívne vyšetrenia sú vhodné?<br>Čo všetko sa dá zistiť z rôznych testov?<br>Naši lekári vám s tým radi pomôžu.",
        "footer": "⏱  Špecialisti v tejto poradni vám odpovedajú do 48h",
        "button": "Spýtať sa lekára",
        "profileSectionButton": "Poradiť sa"
      },
      "final": {
        "title": "Vaša otázka bola úspešne odoslaná",
        "text": "Teraz sa jej venuje náš odborník a hneď ako odpovie na vaše otázky, upozorníme vás e-mailom.",
        "button": "Hotovo"
      },
      "doctors": [
        {
          "name": "MUDr. František Rolinek",
          "specializations": [
            "Praktické lekárstvo pre dospelých"
          ],
          "institution": "MUDr. František Rolinek - ordinácia, Brno",
          "image": "TMP/mudr_frantisek_rolinek.jpeg"
        },
        {
          "name": "MUDr. Lenka Rudolfová",
          "specializations": [
            "Praktické lekárstvo pre dospelých"
          ],
          "institution": "Poliklinika AGEL, Praha",
          "image": "TMP/mudr_lenka_rudolfova.jpeg"
        }
      ]
    }
  },
  "TMP": {
    "fb": {
      "error": "Ospravedlňujeme sa za nepríjemnosti, ale teraz nie je možné sa prihlásiť cez účet na Facebooku. Vzniknuté technické problémy riešime s užívateľskou podporou Facebooku a pracujeme na ich odstránení. Skúste sa, prosím, znovu prihlásiť zajtra alebo zvoľte inú metódu pre prihlásenie/registráciu. Ďakujeme za pochopenie."
    }
  },
  "placeholders": {
    "date": {
      "year": "RRRR",
      "month": "MM",
      "date": "DD"
    },
    "time": {
      "hour": "hh",
      "minute": "mm"
    }
  },
  "unavailableClinics": {
    "title": "Aplikáciu pre vás práve aktualizujeme",
    "description": "Ospravedlňujeme sa za krátkodobý výpadok služby. V súčasnej chvíli nasadzujeme nové vylepšenia aplikácie. O chvíľu budeme späť."
  },
  "releaseNotes": {
    "content": [
      {
        "icon": "date-question"
      },
      {
        "icon": "payment"
      },
      {
        "text": "Postaráme sa za vás o absolvované aj nadchádzajúce termíny.",
        "icon": "report"
      }
    ]
  },
  "healthInsuranceProviderBenefits": {
    "dashboard": {
      "title": "Príspevky poisťovne"
    },
    "title": "Vyberte svoju poisťovňu",
    "privateInsuranceProviders": "Súkromné poisťovne",
    "publicInsuranceProviders": "Verejné poisťovne",
    "showDetail": "Zobraziť podrobnosti",
    "hideDetail": "Skryť podrobnosti",
    "buttonText": "Uložiť poisťovňu a zobraziť",
    "empty": {
      "title": "Žiadne príspevky",
      "text": "Vybraná poisťovňa bohužial príspevky&nbsp;neponúka"
    },
    "fullInfo": {
      "base": "Kompletnú ponuku a podmienky príspevkov nájdete na {link}.",
      "linkText": "stránkach poisťovne"
    },
    "footer": {
      "updated": "Aktualizované {date}",
      "changeCompanyInSettings": "Zmeniť poisťovňu v nastavení",
      "changeCompany": "Zmeniť poisťovňu"
    }
  },
  "explore": {
    "title": "Články",
    "subtitle": "Prečítajte si zdravotné tipy, doporučenia, alebo príbehy",
    "articles": {
      "title": "Články",
      "titleDetail": "Detail článku",
      "shareText": "Posielam zaujímavý článok od uLékaře.cz",
      "footer": {
        "title": "Napadla vás pri čítaní otázka, ktorú chcete položiť lekárovi?",
        "textQuestion": "Radi odpovieme na akúkoľvek otázku ohľadom vášho zdravia, zdravia vášho blízkeho či tohto článku.",
        "textQuestionOrder": "Radi odpovieme na akúkoľvek otázku ohľadom vášho zdravia, zdravia vášho blízkeho či tohto článku."
      }
    },
    "consultations": {
      "titleDetail": "Detail otázky"
    },
    "podcasts": {
      "title": "Podcasty"
    }
  },
  "invitation": {
    "dashboard": {
      "title": "Pozvite rodinu",
      "text": "Služba uLekára.sk pre vašu rodinu. Zadarmo.",
      "buttonText": "Zdieľať pozvánku"
    },
    "title": "Zdravie pre celú rodinu",
    "text": "Pozvite členov svojej rodiny úplne zadarmo. Dáte im tak možnosť nosiť vo vrecku cez 350 lekárov a sestier dostupných 24/7.",
    "list": [
      {
        "icon": "link",
        "text": "Skopírujte odkaz na zdieľanie služby"
      },
      {
        "icon": "rodina",
        "text": "Pošlite ho svojim blízkym."
      },
      {
        "icon": "confetti",
        "text": "Po registrácii sa aktivuje služba zadarmo"
      }
    ],
    "shareLink": "Odkaz na zdieľanie",
    "copyCode": "Skopírovať odkaz",
    "codeCopied": "Skopírované",
    "familyTitle": "Správa rodiny",
    "remove": "Odobrať",
    "shareTitle": "Služba uLekára.sk zadarmo.",
    "shareText": "{personName} s vami zdieľa službu uLekára.sk v rámci rodiny. Budete ju mať zadarmo. Stačí sa zaregistrovať cez odkaz.",
    "emptyMemberName": "Člen rodiny"
  },
  "languageSwitcher": {
    "cz": "Čeština",
    "sk": "Slovenčina",
    "en": "English",
    "uk": "Українська",
    "ru": "Русский язык",
    "hu": "Magyar"
  },
  "medicalProcedure": {
    "editReport": "Upraviť",
    "markAsDone": "Označiť za splnené",
    "notes": "Vaše poznámky",
    "notesPlaceholder": "Pridajte svoje osobné poznámky ...",
    "uploadFiles": "Nahrajte súbory",
    "information": "Informácie",
    "content": {
      "content1": "Čo ma čaká?",
      "content2": "Ako sa mám pripraviť?",
      "content3": "Je prehliadka hradená?",
      "content4": "Ako na to?",
      "content5": "Kedy robiť vyšetrenie?",
      "content6": "Čo keď nájdem niečo znepokojivé?",
      "content7": "Ako sa prenáša?",
      "content8": "Existuje nejaká prevencia?",
      "content9": "Akú vakcínu mám zvoliť?"
    },
    "boxes": {
      "recommended": "Doporučené",
      "male": "Mužom",
      "female": "Ženám",
      "from": "od",
      "interval": "Interval",
      "showDetail": "Zobraziť detail",
      "letsStart": "Poďme začať",
      "noRecords": "Nevyplnené"
    },
    "examination": {
      "title": "Detail prehliadky",
      "add": "Zaznamenať prehliadku",
      "listTitle": "Moje prehliadky",
      "newFormPerex": "Zapíšte si dátum prehliadky. Môžete si taktiež uložiť poznámky a súbory (foto, lekárske správy atď.).",
      "editFormPerex": "Tu si môžete upraviť dátum, poznámky a spravovať súvisiace súbory.",
      "optional": "Dobrovolná prehliadka",
      "recommended": "Povinná prehliadka",
      "type": "Prehliedka",
      "nextBy": "Ďalšia prehliadka do",
      "next": "Ďalšia prehliadka",
      "last": "Posledná prehliadka",
      "new": "Nová prehliedka",
      "date": "Dátum prehliadky",
      "time": "Čas prehliadky",
      "past": "Absolvovaná",
      "pastMulti": "Absolvované",
      "future": "Nadchádzajúce",
      "missedNotification": "Bol prekročený predpísaný interval prehliadky.",
      "emptyNotification": "Tu si můžete zapisovať a spravovať svoje prehliadky.",
      "errorDateEmpty": "Vyplňte prosím dátum prehliadky.",
      "errorDateBoundsPast": "Vyplňte prosím dátum už absolvovanej prehliadky.",
      "errorDateBoundsFuture": "Termín musí byť v budúcnosti.",
      "todayDateCheckboxLabel": "Prehliadka prebehla dnes",
      "manageReports": "Moje prehliadky",
      "emptyPlaceholder": {
        "title": "Zaznamenajte si prvú prehliadku",
        "perex": "Udržať si prehľad vo svojich prehliadkach nebolo nikdy jednoduchšie"
      }
    },
    "vaccination": {
      "title": "Detail očkovania",
      "add": "Zaznamenať očkovanie",
      "listTitle": "Moje očkovanie",
      "newFormPerex": "Zapíšte si dátum očkovania. Môžete si taktiež uložiť poznámky a súbory (foto, lekárske správy atď.).",
      "editFormPerex": "Tu si môžete upraviť dátum, poznámky a spravovať súvisiace súbory.",
      "optional": "Dobrovolné očkovanie",
      "recommended": "Povinné očkovanie",
      "type": "Očkovanie",
      "nextBy": "Ďalšie očkovanie do",
      "next": "Ďalšie očkovanie",
      "last": "Posledné očkovanie",
      "new": "Nové očkovanie",
      "date": "Dátum očkovania",
      "time": "Čas očkovania",
      "past": "Absolvované",
      "pastMulti": "Absolvované",
      "future": "Nadchádzajúce",
      "missedNotification": "Bol prekročený predpísaný interval očkovania.",
      "emptyNotification": "Tu si môžete zapisovať a spravovať svoje očkovania.",
      "errorDateEmpty": "Vyplňte prosím dátum očkovania.",
      "errorDateBoundsPast": "Vyplňte prosím dátum už absolvovaného očkovania.",
      "errorDateBoundsFuture": "Termín musí byť v budúcnosti.",
      "todayDateCheckboxLabel": "Očkovanie prebehlo dnes",
      "manageReports": "Moje očkovanie",
      "emptyPlaceholder": {
        "title": "Zaznamenajte si prvé očkovanie",
        "perex": "Udržať si prehľad vo svojich očkovaniach nebolo nikdy jednoduchšie"
      }
    },
    "trash": {
      "title": "Naozaj chcete záznam vymazať?",
      "text": "Záznam vrátane prípadných poznámok a príloh nenávratne vymažte.",
      "keep": "Ponechať",
      "delete": "Vymazať záznam"
    }
  },
  "intervals": {
    "months": {
      "single": "mesiac",
      "plural": "mesiacov",
      "semi": "mesiace"
    },
    "years": {
      "single": "rok",
      "plural": "rokov",
      "semi": "roky"
    }
  },
  "aeskulab": {
    "title": "Žiadosť o interpretáciu výsledkov laboratórnych testov",
    "text": "Jednoduchým spôsobom môžete získať písomnú interpretáciu výsledkov svojho vyšetrenia, ktoré prebehlo v laboratóriu Unilabs. Vaše výsledky posúdi buď interný lekár, alebo klinický genetik. V rámci jednej zakúpenej interpretácie poskytne svoje stanovisko iba jeden z nich.",
    "buttonText": "Vyplniť  žiadosť",
    "howItWorks": {
      "title": "Ako to funguje?",
      "items": [
        {
          "icon": "chat",
          "perex": "Odošlite žiadosť s priloženým pdf dokumentom s výsledkami laboratórnych testov."
        },
        {
          "icon": "mail",
          "perex": "Do 24 hodín vám pošleme interpretáciu výsledkov testov prostredníctvom e-mailu."
        },
        {
          "icon": "calendar/date-31",
          "perex": "Ak bude treba, môžete si následne dohodnúť telefonický hovor so zdravotnou sestrou."
        }
      ]
    },
    "form": {
      "thankYou": {
        "title": "Ďakujeme za vašu žiadosť",
        "perex": "Vaše laboratórne výsledky a všetky údaje sme práve odoslali na spracovanie.\nInterpretáciu výsledkov testov dostanete do 24 hodín prostredníctvom e-mailu."
      },
      "personalData": {
        "text": "Zoznámil/-a som sa so {link} poskytovateľa zdravotných služieb uLékaře.cz Health Care",
        "link": "zásadami spracovania osobných údajov"
      },
      "termsConds": {
        "text": "Zoznámi/-al som sa s {link} a so {cookies} a súhlasím s nimi.",
        "link": "podmienkami používania platformy uLékaře.cz",
        "cookies": "zásadami používania súborov cookie platformy uLékaře.cz"
      }
    },
    "formTitle": "Formulár žiadosti",
    "email": "health.care@ulekare.cz",
    "phone": "+420&nbsp;253&nbsp;253&nbsp;155",
    "errorAuthorization": "Váš odkaz je neplatný, kontaktujte prosím oddelenie starostlivosti o zákazníkov <a href=\"https://sk.unilabs.online/faq\" target=_blank\">sk.unilabs.online</a>.",
    "formButtons": {
      "text": "Použijeme údaje z webu sk.unilabs.online",
      "others": "Pýtam sa na inú osobu"
    },
    "emergency": "Služba uLékaře.cz nenahrádza záchrannú službu. Pri akútnych problémoch <a href=\"tel:155\" class=\"link--inline black--text\">volajte linku 155</a>.",
    "footer": {
      "copyright": "&copy; {thisYear} uLékaře.cz Health Care, s.r.o.",
      "leftText": "Poskytovateľ zdravotných služieb uLékaře.cz Health Care, s.r.o. Prevádzku webových stránok zaisťuje spoločnosť uLékaře.cz, s.r.o.",
      "rightText": "Unilabs je prevádzkovateľ služby sk.unilabs.online a najväčší poskytovateľ laboratórnych služieb a diagnostiky na Slovensku."
    }
  },
  "dateInput": {
    "errors": {
      "invalidFormatDate": "Vyplňte prosím dátum v správnom formáte medzi {min} a {max}",
      "invalidFormatMonth": "Vyplňte prosím mesiac v správnom formáte medzi {min} a {max}"
    }
  },
  "timeInput": {
    "errors": {
      "invalidFormat": "Vyplňte prosím čas v správnom formáte medzi 0:00 a 23:59",
      "required": "Vyplňte prosím čas"
    }
  },
  "feedback": {
    "text": "Vaše hodnotenie je náš vitamín. Zlepšujeme zdravie tejto aplikácie aj&nbsp;vďaka vám.",
    "label": "Máte nejaké nápady na zlepšenie?",
    "placeholder": "Tu nám ich môžete prezradiť...",
    "thankYou": {
      "title": "Ďakujeme za spätnú väzbu",
      "text": "Urobíme maximum, aby sme vám uľahčili starostlivosť o&nbsp;zdravie."
    },
    "menu": "Spätná väzba",
    "panelButton": "Vyplniť spätnú väzbu"
  },
  "newsletterAgreement": {
    "dashboard": {
      "title": "Zdravie e-mailom",
      "text": "Novinky a zľavy vám pošleme do e-mailu."
    },
    "title": "Pošleme vám zdravie do schránky",
    "perex": "Tu začína vaša cesta k dlhodobému zdraviu.",
    "content": [
      {
        "icon": "confetti",
        "text": "Pravidelné tipy, ako si udržať životnú pohodu."
      },
      {
        "icon": "care",
        "text": "Zaujímavé zľavy na pomocníkov, ktorí utužujú zdravie."
      },
      {
        "icon": "news",
        "text": "Upozornenie na nové články, ktoré vás baví čítať."
      }
    ],
    "footer": {
      "text": "Kliknutím na tlačidlo \"Odoberať\" súhlasíte so {link}.",
      "linkText": "zaslaním marketingových oznámení"
    }
  },
  "addressInput": {
    "country": "Štát",
    "postcode": "PSČ",
    "street": "Ulica a číslo domu"
  },
  "videocall": {
    "chooseDate": "Vyberte si dátum",
    "confirmReservation": "Potvrdiť rezerváciu",
    "reservationProgressing": "Potvrdzovanie prebieha",
    "dayOfWeek": [
      "Ne",
      "Po",
      "Ut",
      "St",
      "Št",
      "Pi",
      "So"
    ],
    "month": [
      "Január",
      "Február",
      "Marec",
      "Apríl",
      "Máj",
      "Jún",
      "Júl",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "thankYou": {
      "info": "Všetky potrebné informácie sme vám poslali e-mailom.",
      "success": "Videohovor bol úspešne naplánovaný 🎉",
      "close": "Zavrieť"
    }
  },
  "homepage": {
    "footer": {
      "copyright": "uLekára.sk"
    },
    "contact": {
      "mail": {
        "subject": "Na zdraví Vašich zamestnancov nám záleží, čoskoro sa Vám ozveme",
        "content": "Pekný deň,<br/><br/>\nďakujeme za Váš záujem o službu Zdravie a prevencia vo firme. Sme radi, že sa staráte o zdravie svojich zamestnancov. Ozveme sa Vám najneskôr nasledujúci pracovný deň.<br/><br/>\nS pozdravem<br/><br/>\nMartin Čuba, Business Development Manager<br/>\ne-mail: <a href=\"mailto:partner@ulekare.cz\">partner@ulekara.sk</a><br/>\ntel.: <a href=\"tel:00420602413933\">+420 603 841 995</a>",
        "footer": {
          "copyright": "uLekára.sk"
        }
      }
    }
  },
  "secondFactor": {
    "label": "Zadajte kód, ktorý vám prišiel na overenie prihlásenia.",
    "error": {
      "input": "Zadajte kód."
    }
  },
  "forms": {
    "Question": {
      "patient": {
        "whoisAsking": {
          "other": {
            "label": "Na niekoho iného"
          }
        },
        "birthNumber": {
          "self": {
            "label": "Rodné číslo",
            "help": "Vaše rodné číslo je potrebné na komunikáciu so zdravotníckymi zariadeniami."
          },
          "other": {
            "label": "Rodné číslo",
            "help": "Vaše rodné číslo je potrebné na komunikáciu so zdravotníckymi zariadeniami."
          }
        }
      },
      "questionBasic": {
        "questionWhat": {
          "label": "Popíšte zdravotný problém a všetky jeho prejavy. Čím podrobnejší popis, tým presnejšia odpoveď lekára."
        },
        "questionSolutionCountry": {
          "label": "V ktorej krajine chcete pomôcť?"
        }
      },
      "questionAdditional": {
        "title": "Doplňujúce informácie pre lekárov",
        "questionAnotherSickness": {
          "self": {
            "label": "Liečite sa na nejaké chronické/iné ochorenie?"
          }
        },
        "questionAnotherSicknessDetails": {
          "self": {
            "label": "Prosím napíšte, s ktorým ochorením sa liečite."
          }
        },
        "questionContact": {
          "yes": "Áno, želám si, aby ma kontaktovala zdravotná sestra.",
          "no": "Nie, nechcem, aby mi zdravotná sestra zavolala."
        }
      }
    },
    "Order": {
      "patient": {
        "title": "Základné informácie",
        "firstName": {
          "other": {
            "label": "Meno inej osoby"
          }
        },
        "birthNumber": {
          "self": {
            "label": "Rodné číslo",
            "help": "Vaše rodné číslo je potrebné na komunikáciu so zdravotníckymi zariadeniami."
          },
          "other": {
            "label": "Rodné číslo",
            "help": "Vaše rodné číslo je potrebné na komunikáciu so zdravotníckymi zariadeniami."
          }
        }
      },
      "orderBasic": {
        "orderWhat": {
          "label": "S čím potrebujete pomôcť?",
          "placeholder": "Napríklad poradiť, kam sa obrátiť…"
        },
        "orderSpecialist": {
          "label": "Aký typ lekára alebo špecialistu hľadáte?"
        },
        "orderLocality": {
          "label": "V ktorej lokalite chcete problém riešiť?"
        },
        "orderTimeAvailability": {
          "label": "Ak bude trieba, na aký termín si prajete objednať?"
        },
        "orderContact": {
          "label": "Ako chcete pomôcť s požiadavkou?",
          "yes": "Uprednostňujem, aby ste objednávku vybavili za mňa.",
          "no": "Uprednostňujem zaslanie kontaktov."
        }
      }
    }
  },
  "ePrescription": {
    "orderDisclaimer": {
      "b2b": "E-recept môžeme sprostredkovať na základe odporúčania lekára v našej poradni. V rámci služby sprievodca zdravím to nie je možné. {disclaimerLink}",
      "b2c": "E-recept môžeme sprostredkovať na základe odporúčania lekára v našej poradni. V rámci služby objednania to nie je možné. {disclaimerLink}"
    },
    "orderDisclaimerLink": "Spýtajte sa lekára"
  }
}